import { ContactMeetingState } from '@omni/classes/contact/contact.class';
import { NextCallObjectiveDataService } from '../next-call-objective/next.call.objective.data.service';
import { MSEventsService } from './../../services/ms-events.service';
import { LiveMeetActivity, MeetingObjective } from './../../classes/activity/appointment.activity.class';
import { Injectable } from "@angular/core";
import { Endpoints } from "../../../config/endpoints.config";
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { ActivityService } from "../../services/activity/activity.service";
import { SampleDeliveryRequestService } from "../../services/sample/sample-delivery-request.service";
import { AuthenticationService } from "../../services/authentication.service";
import { LogService } from "../../services/logging/log-service";
import { MeetingStatus } from "../../classes/meeting/meeting.class";
import { Activity, MeetingActivityType, ActivityTypeCodeRaw, MeetingActivityTypeCode, FormatType, ActivityType } from "../../classes/activity/activity.class";
import { DeviceService } from "../../services/device/device.service";
import { DiskService, OFFLINE_DATA_COUNT_ENTITY_NAME, OFFLINE_DB_LINKED_ENTITY_NAME } from "../../services/disk/disk.service";
import { AppointmentActivity, OFFLINE_ID_PREFIX } from "../../classes/activity/appointment.activity.class";
import { MeetingSummaryKeyMessage } from "../../models/nova-voice.model";
import { Account } from "../../classes/account/account.class";
import {
  Presentation,
  Products
} from "../../classes/presentation/presentation.class";
import { Contact } from "../../classes/contact/contact.class";

import { Events } from '@omni/events';
import { ActivityDataService } from "../activity/activity.service";
import { GlobalErrorHandler } from "../../services/error-handler/error-handler-service";
import { ContactOfflineService } from "../../services/contact/contact.service";
import { DateTimeFormatsService } from '@omni/services/date-time-formats/date-time-formats.service';
import { DB_KEY_PREFIXES } from "../../config/pouch-db.config";
import { AccompainedUser } from "../../classes/activity/accompained-user.class";
import { UIService } from "../../services/ui/ui.service";
import { TranslateService } from '@ngx-translate/core';
import { NotificationService, ToastStyle } from '../../services/notification/notification.service';
import { Resource } from '../../classes/resource/resource.class';
import { GlobalUtilityService } from '../../services/global-utility.service';
import { PhoneActivity } from '../../classes/activity/phone.activity.class';
import { ConfiguredFields } from '@omni/classes/authentication/configured.field.class';
import { delay, mergeMap, retryWhen, timeout } from 'rxjs/operators';
import { ErrorCode } from './../../enums/exception/general-error-codes.enum';
import { GeneralException } from './../../classes/exception/general-exception.class';
import { DynamicsBoolean } from '../../enums/shared-enums';
import { LoadingController } from '@ionic/angular';
import { FeatureActionsMap, IoConfigurationFeatureCodes } from '@omni/classes/authentication/user.class';
import { AuthenticationDataService } from '../authentication/authentication.service';
import { DynamicsClientService } from '../dynamics-client/dynamics-client.service';
import { Guid } from 'typescript-guid';
import { IONote } from '@omni/classes/io/io-note.class';
import { fetchQueries } from '@omni/config/dynamics-fetchQueries';
import { AlertService } from '@omni/services/alert/alert.service';
import { throwError, timer } from 'rxjs';
import { UploadedPhoto } from '@omni/classes/store-check/uploaded-photo';
import { GPSActivityPhoto, Photo, PhotoResponse } from '@omni/classes/store-check/photo';
import { AppealDataService } from '../appeal/appeal.data.service';
import { ActivityPresentationSlideContact } from '@omni/classes/presentation/activity-slide-contacts.class';
import { SENTIMENT } from '../websocket/payloads/sentiment.payload';
import { SecInfoConfigDataService } from '../sec-info-config/sec-info-config-data-service';
import { AccountOfflineService, AccountSelectedFor } from '@omni/services/account/account.offline.service';
import { Brand } from '@omni/classes/brand/brand.class';
import { SecondaryInfoEntityName } from '@omni/classes/sec-info-config/sec-info.class';
import { LocationCoordinates } from '@omni/interfaces/shared/shared.interface';
import { MeetingChartId } from '@omni/enums/edge-analytics/meeting/meeting-report.enum';
import { EntityNameForTranslation, LocalizationService } from '@omni/services/localization/localization.service';
import { cloneDeep, intersectionBy, intersectionWith, isEmpty, isEqual, maxBy, toNumber, xorBy, xorWith } from 'lodash-es';

export interface MeetingCreateResponseDTO {
  activityId: string,
  indskr_isofflinemeeting: boolean,
  indskr_meetingurl: string,
  meetingTopicName: string,
  offlineMeetingId: string,
  createdContacts?: Array<{ contactId: string, activityContactId: string }>,
  createdAccounts?: Array<{ accountId: string, activityAccountId: string }>
};

enum ActivityContentShareTypeOptionSetValue {
  Audio = 1,
  Video,
  Screen,
  ShareContentLinkToMessagingApp,
};

@Injectable({
  providedIn: 'root'
})
export class MeetingDataService {
  public isErrorStartDateCreateMeeting: boolean = false;
  public isErrorStartDateUpdateMeeting: boolean = false;
  public meetingObjectives: MeetingObjective[] = [];
  constructor(
    private http: HttpClient,
    private activityService: ActivityService,
    private activityDataService: ActivityDataService,
    private authenticationService: AuthenticationService,
    private authDataService: AuthenticationDataService,
    private contactService: ContactOfflineService,
    private logService: LogService,
    private deviceService: DeviceService,
    private disk: DiskService,
    private events: Events,
    private errorHandler: GlobalErrorHandler,
    private uiService: UIService,
    private msEventService: MSEventsService,
    private nextCallObjectiveDataService: NextCallObjectiveDataService,
    private translate: TranslateService,
    private notificationService: NotificationService,
    private globalUtility: GlobalUtilityService,
    private loadingCtrl: LoadingController,
    private dynamics: DynamicsClientService,
    private alertService: AlertService,
    private appealDataService: AppealDataService,
    private secondaryInfoService: SecInfoConfigDataService,
    private accountService: AccountOfflineService,
    private localisationService: LocalizationService,
    private readonly dateTimeFormatsService: DateTimeFormatsService,
    private readonly sampleDeliveryRequestService: SampleDeliveryRequestService,
  ) { }

  private readonly THREE_DAYS = 4;


  getContactAttendeePayload(contact: Contact, clearJoinStatus?: boolean) {
    if (!contact) {
      return null;
    }
    const contactAttendee = {
      indskr_contactid: contact.ID,
      indskr_name: contact.fullName.trim(),
      indskr_isguest: contact.isguest,
      indskr_joinstatus: contact.connectionState,
      indskr_isremote: contact.isremote,
      indskr_leftmanually: contact.isleftmanually,
    };
    if (clearJoinStatus) {
      contactAttendee.indskr_leftmanually = false;
      contactAttendee.indskr_joinstatus = ContactMeetingState.NOTJOINED;
    } else {
      if (contact.join_date && contact.join_date != "" && contact.join_date != "null") {
        contactAttendee['indskr_joineddate'] = this.dateTimeFormatsService.isValidDate(new Date(contact.join_date)) ? this.dateTimeFormatsService.formatDate(contact.join_date, 'YYYY-MM-DDTHH:mm:ssZ') : this.dateTimeFormatsService.formatDate(parseFloat(contact.join_date), 'YYYY-MM-DDTHH:mm:ssZ');
      }
      if (contact.left_date && contact.left_date != "" && contact.left_date != "null") {
        contactAttendee['indskr_leftdate'] = this.dateTimeFormatsService.isValidDate(new Date(contact.left_date)) ? this.dateTimeFormatsService.formatDate(contact.left_date, 'YYYY-MM-DDTHH:mm:ssZ') : this.dateTimeFormatsService.formatDate(parseFloat(contact.left_date), 'YYYY-MM-DDTHH:mm:ssZ');
      }
    }
    return contactAttendee;
  }

  /**
   * Maps the current selected activity contacts then makes a network request
   *
   * @param {Activity} activity
   * @memberof MeetingDataService
   */
  public async addContactsToMeeting(activity: Activity, clearJoinStatus?: boolean): Promise<boolean> {
    if (this.deviceService.isOffline || this.deviceService.isDeviceRealOffline || this.activityService.hasOfflineMeetingData(activity.ID) ||
      activity.ID.includes('offline') || !(activity instanceof AppointmentActivity)) {
      return false;
    }

    const url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
      Endpoints.meeting.PATCH_MEETING_CONTACTS_V2.replace('{activity_id}', activity.ID);

    let headers = new HttpHeaders();
    headers = headers.set(
      "X-PositionId",
      this.authenticationService.user.xPositionID
    );

    const contacts = cloneDeep(activity.contacts);

    // Compute delta vs raw contact attendees stored on the activity
    const rawContacts: any[] = (activity as AppointmentActivity)._raw_contactAttendees || [];
    const rawContactIds = new Set(rawContacts.map((r: any) => r.indskr_contactid));
    const currentContactIds = new Set(contacts.map(c => c.ID));

    const addedContacts = contacts.filter(c => !rawContactIds.has(c.ID));
    const added = addedContacts
      .map(c => this.getContactAttendeePayload(c, clearJoinStatus))
      .filter(Boolean);

    const removedRaw = rawContacts.filter((r: any) => !currentContactIds.has(r.indskr_contactid));
    const removed = removedRaw
      .map((r: any) => r.indskr_activitycontactid || r.contactAttendeeId)
      .filter(Boolean);

    const deltaPayload = { added, updated: [], removed };

    // Diagnostic for the recurring ERR_IO_500 "Duplicate Detected... already
    // been mapped" reports (OMNI-61272 follow-ups) — logs the exact delta and
    // the snapshot it was computed against, so a live repro can confirm
    // whether a contact already in _raw_contactAttendees is still ending up
    // in `added[]` (which would mean activity._raw_contactAttendees/contacts
    // was reset/reloaded from a stale snapshot before this ran), rather than
    // guessing from static code reading alone. Safe to remove once confirmed.
    console.log('[SDR/Meeting-contacts] addContactsToMeeting delta', {
      activityId: activity.ID,
      currentContactIds: [...currentContactIds],
      rawContactIds: [...rawContactIds],
      added: addedContacts.map(c => c.ID),
      removed: removedRaw.map((r: any) => r.indskr_contactid),
    });

    try {
      const response: any = await this.http.patch(url, deltaPayload, { headers }).toPromise();
      // Keep _raw_contactAttendees in sync with what was just confirmed
      // server-side — without this, a SECOND addContactsToMeeting call later
      // in the same session recomputes its delta against the same stale
      // snapshot (still missing whatever this call just added) and resends
      // an already-mapped contact in `added[]`, which Dynamics rejects with
      // "Duplicate Detected... already been mapped" (ERR_IO_500) — e.g.
      // replacing an SDR's contact with a different one, when the first
      // contact was already attached to the meeting moments earlier.
      // Mirrors the mapping appendContactsToMeeting already uses.
      const removedContactIds = new Set(removedRaw.map((r: any) => r.indskr_contactid));
      const survivingRaw = rawContacts.filter((r: any) => !removedContactIds.has(r.indskr_contactid));
      const createdContacts: Array<{ contactId: string; activityContactId: string }> = response?.createdContacts || [];
      const newlyAddedRaw = addedContacts.map(c => {
        const created = createdContacts.find(cc => cc.contactId === c.ID);
        return {
          activityId: activity.ID,
          indskr_activitycontactid: created?.activityContactId,
          indskr_contactid: c.ID,
          indskr_name: c.fullName?.trim() || '',
          indskr_joineddate: '',
          indskr_leftdate: '',
          indskr_sequence: null,
        };
      });
      (activity as AppointmentActivity)._raw_contactAttendees = [...survivingRaw, ...newlyAddedRaw];

      for (let contact of activity.contacts) {
        if (contact.isUsedInOneTimeMeeting) {
          this.dynamics.dwa.updateSingleProperty(contact.ID, "contacts", { omniveev_isusedinonetimemeeting: true });
        }
        if (contacts.length > 0) {
          this.copyPageSentiments(activity, contacts);
          this.mapPageSentimentsInLocalDB(activity);
        }
      }
      return true;
    } catch (error) {
      console.error('addContactsToMeeting: ', error);
      await this.activityService.upsertMeetingsOfflineData(activity, true, true);
      return false;
    }
  }


  public async removePageSentiments(activity: Activity, contacts) {
    if (!this.deviceService.isOffline) {
      let removePageSentimentsUrl: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
        Endpoints.meeting.COPY_SENTIMENT_TO_ATTENDEESLIDE.replace(
          "{activity_id}",
          activity.ID
        );

      let headers = new HttpHeaders();
      headers = headers.set(
        "X-PositionId",
        this.authenticationService.user.xPositionID
      );

      let customers = contacts.map(con => {
        return ({
          "indskr_contactid": con.ID,
          "indskr_name": con.fullName.trim(),
        }
        )
      })
      let removePageSentimentsPayload = {
        "presentations": [],
        "contacts": [],
        "removedContacts": customers
      }

      try {
        await this.http.put(removePageSentimentsUrl, removePageSentimentsPayload, { headers }).toPromise();
      } catch (error) {
        console.error('addContactsToMeeting: ', error);
        return false;
      }
    } else {
      let presSlide = [];
      (activity as AppointmentActivity).activityPresentations.forEach(sentiment => {
        presSlide = sentiment.activityPresentationSlides
      })
      presSlide.forEach(sentiment => {
        if (sentiment.activityPresentationSlideContacts) {
          sentiment.activityPresentationSlideContacts = [];
        }
      })
    }

  }

  public async copyPageSentiments(activity: Activity, contacts) {
    let copyPageSentimentsUrl: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
      Endpoints.meeting.COPY_SENTIMENT_TO_ATTENDEESLIDE.replace(
        "{activity_id}",
        activity.ID
      );

    let headers = new HttpHeaders();
    headers = headers.set(
      "X-PositionId",
      this.authenticationService.user.xPositionID
    );
    if (this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_KEY_MESSAGE_SENTIMENT) && (activity as AppointmentActivity).activityPresentations && (activity as AppointmentActivity).activityPresentations.length) {
      let presentations = (activity as AppointmentActivity).activityPresentations.map(presenatation => {
        return ({
          "indskr_iopresentationid": presenatation.presentationId
        })
      });
      let customers = contacts.map(con => {
        return ({
          "indskr_contactid": con.ID,
          "indskr_name": con.fullName.trim(),
        }
        )
      })
      let copyPageSentimentsPayload = {
        presentations,
        "contacts": customers,
        "removedContacts": []
      }
      try {
        await this.http.put(copyPageSentimentsUrl, copyPageSentimentsPayload, { headers }).toPromise();
      } catch (error) {
        console.error('addContactsToMeeting: ', error);
        return false;
      }
    }
    return true;
  }

  public async mapPageSentimentsInLocalDB(activity) {
    let presSlide;
    (activity as AppointmentActivity).activityPresentations.forEach(sentiment => {
      presSlide = sentiment.activityPresentationSlides
    })
    if(presSlide) {
      presSlide.forEach(sentiment => {
        for (let slideContact of activity.contacts) {
          let contact = new ActivityPresentationSlideContact({
            indskr_contactid: slideContact.ID,
            indskr_name: `${slideContact.firstName} ${slideContact.lastName}`,
            indskr_pagestartdate: sentiment.starttime ? sentiment.starttime : null,
            indskr_pageenddate: sentiment.endtime ? sentiment.endtime : null,
          });
          if (sentiment.activityPresentationSlideContacts) {
            sentiment.activityPresentationSlideContacts.push(contact);
          }
          contact.pagesentiment = sentiment.pagesentiment ? sentiment.pagesentiment : SENTIMENT.NEUTRAL;
        }
      })
    }
  }
  public async loadOfflineMeetings() {
    let offlineMeetingDocument = await this.disk.loadOfflineMeetings();
    if (
      offlineMeetingDocument &&
      offlineMeetingDocument.meetings &&
      Array.isArray(offlineMeetingDocument.meetings)
    ) {
      offlineMeetingDocument.meetings.map(offlineMeeting => {
        //Create the activity
        let activity = new AppointmentActivity(offlineMeeting);

        //Check the state and status code
        if (activity.state === 2) return;
        if (activity.status === 4) return;

        //Let activity service update fn do its magic
        this.activityDataService._appendMeetingDetailsToActivity(
          activity,
          offlineMeeting
        );
        this.activityService.displayActivities.push(activity);
        console.log(activity);
      });
    }
    if (!this.uiService.toolsActivityActive) {
      this.events.publish('refreshAgenda');
    } else this.uiService.agendaRefreshRequired = true;
  }

  /** Whether we can make a direct API call for this meeting (not offline, no pending offline data, not offline-created). */
  private _shouldCallMeetingApi(meetingId: string): boolean {
    return !this.deviceService.isOffline
      && !this.activityService.hasOfflineMeetingData(meetingId)
      && !meetingId.includes('offline');
  }

  /**
   * Updates an activity with the payload details
   *
   * @param {AppointmentActivity} activity
   * @param {UpdateMeetingPayload} payload
   * @memberof MeetingDataService
   */
  public async updateMeeting(
    activity: AppointmentActivity,
    payload: UpdateMeetingPayload,
    updateMeetingType: boolean = false,
    notifyCalendarInviteUpdate: boolean = false,
    doNotPublishActivityEvent: boolean = false,
    isUpdateStartDate: boolean = false,
    isUpdateStartDateMeetingPresentaion: boolean = false,
  ) {
    const hasOfflineData = this.activityService.hasOfflineMeetingData(activity.ID);
    this.isErrorStartDateUpdateMeeting = false;
    activity.modified = new Date();
    // We check if there's any existing offline data for this meeting
    if (!this.deviceService.isOffline && !hasOfflineData) {
      let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.PATCH_MEETING_V2;

      url = url.replace("{activity_id}", activity.ID);

      let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
      headers.headers = headers.headers.set(
        "X-PositionId",
        this.authenticationService.user.xPositionID
      );
      const { timeZone } = Intl?.DateTimeFormat()?.resolvedOptions();
      if (timeZone) {
        headers.headers = headers.headers.set(
          'X-Zone-Id',
          timeZone,
        );
      }
      const isGracePeriodCheck: string = (!this.deviceService.isOffline && (isUpdateStartDate || isUpdateStartDateMeetingPresentaion)).toString();
      const pastActivityGracePeriod: string = isGracePeriodCheck ? (this.authenticationService.user.maxMeetingStartDays).toString() : '';
      let headerAndPrarms = {
        ...headers,
        params: {
          'isGracePeriodCheck': isGracePeriodCheck,
          'pastActivityGracePeriod': pastActivityGracePeriod,
        }
      }

      try {
        let response;
          if (payload.meetingOutcomeId) {
          response = await this.http.patch(url, { indskr_caseoutcome: payload.meetingOutcomeId }, headerAndPrarms).toPromise();
        } else {
          response = await this.http.patch(url, payload.getRequestBody(), headerAndPrarms).toPromise();
        }

        this.logService.logDebug(response);

        if (response) {
          // Notify calendar invite update
          if (notifyCalendarInviteUpdate) {
            this.activityService.notifyCalendarInviteUpdate(activity);
          }

          if(payload.subject) activity.subject = payload.subject;
          if (payload.location !== undefined) activity.location = payload.location;
          if (payload.scheduledStart) activity.scheduledStart = payload.scheduledStart;
          if (payload.scheduledEnd)activity.scheduledEnd = payload.scheduledEnd;
          if (payload.notes) activity.notes = payload.notes;
          if (payload.indskr_meetingtype) activity.indskr_meetingtype = payload.indskr_meetingtype;
          if (payload.meetingOutcomeId) {
            activity.meetingOutcomeId = payload.meetingOutcomeId;
            activity.meetingOutcomeString = payload.meetingOutcomeString;
          }
          if (payload.indskr_kitbooking) activity.indskr_kitbooking = payload.indskr_kitbooking;
          await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity as AppointmentActivity, true);
          if (!doNotPublishActivityEvent) {
            // Date Time is updated on calendar view
            // After the update, calendar view needs to refresh the cell data from displayActivities array
            // Hence, we want to update the record in displayActivities array before publishing an update event
            // We can publish refreshAgenda event but try to update only the record in the array instead
            // because running refreshAgenda is expensive.
            const displayActivity = this.activityService.displayActivities.find(a => a.ID === activity.ID);
            if (displayActivity) {
              displayActivity.scheduledStart = new Date(activity.scheduledStart);
              displayActivity.scheduledEnd = new Date(activity.scheduledEnd);
              this.activityService.publishActivityEvent({action: "Update", activity: activity});
            }
          }
          return true;
        }
      } catch (httpError) {
        this.errorHandler.handleError(httpError);
        const errorInfo = (httpError.hasOwnProperty('error')) ? httpError.error : httpError;
        if (errorInfo.errorCode == "ERR_IO_ME12") {
          this.isErrorStartDateUpdateMeeting = true;
          if (!isUpdateStartDateMeetingPresentaion) {
            const restrictMeetingCreationForPastDateAndTimeFlag = this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.RESTRICT_MEETING_CREATION_FOR_PAST_DATE_AND_TIME) as boolean;
            if (restrictMeetingCreationForPastDateAndTimeFlag) {
              this.notificationService.notify(
                this.translate.instant('CAN_NOT_SCHEDULE_MEETING_FOR_PAST_DATE_AND_TIME'),
                'Date Time Picker','top',ToastStyle.DANGER
              );
            } else {
              this.notificationService.notify(this.translate.instant(
                'NEW_ACTIVITY_TOAST_CAN_NOT_SCHEDULE_MEETING', 
                { maxMeetingStartDays: this.authenticationService.user.maxMeetingStartDays }), 
                'Date Time Picker', 'top', ToastStyle.DANGER
              );
            }            
          }
        }
        if (updateMeetingType) {
          return Promise.reject(httpError);
        }
      }
    } else {
      // Offline or has pending offline data — update local DB only
      try {
        if (payload.indskr_meetingtype)
          activity.indskr_meetingtype = payload.indskr_meetingtype;

        if (payload.meetingOutcomeId) {
          activity.meetingOutcomeId = payload.meetingOutcomeId;
          activity.meetingOutcomeString = payload.meetingOutcomeString;
        }
        await this.activityService.upsertMeetingsOfflineData(activity as AppointmentActivity);
      } catch (error) {
        console.error('updateMeeting: ', error);
        if (updateMeetingType) {
          return Promise.reject(error);
        }
      }
    }
  }

  public async rescheduleAppointment(
    activity: AppointmentActivity,
    newStart: Date,
    newEnd: Date,
  ): Promise<void> {
    const hasOfflineData = this.activityService.hasOfflineMeetingData(activity.ID);
    const payload = UpdateMeetingPayload.diff(activity, { scheduledStart: newStart, scheduledEnd: newEnd });

    this.dateTimeFormatsService.updateLimitedMinTime.next({ startDateTime: newStart, endDateTime: newEnd });

    if (!this.deviceService.isOffline && !hasOfflineData) {
      // Online: reuse updateMeeting — handles PATCH + displayActivities update + event publish
      await this.updateMeeting(activity, payload, true, false, false, true /* isUpdateStartDate */);
      // updateMeeting internally calls updateOrInsertActivityToActivityDetailRawDocument
      // with doNotInsert=true, which silently skips when the PouchDB document doesn't
      // exist yet (e.g. a newly created meeting whose detail record hasn't been stored
      // locally). A second call with doNotInsert=false guarantees the new start/end are
      // persisted so the meeting survives a page reload without waiting for delta sync.
      activity.scheduledStart = newStart;
      activity.scheduledEnd   = newEnd;
      await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity, false);
    } else {
      // Offline: apply locally and queue for sync
      activity.modified        = new Date();
      activity.scheduledStart  = newStart;
      activity.scheduledEnd    = newEnd;
      const displayActivity = this.activityService.displayActivities.find(a => a.ID === activity.ID);
      if (displayActivity) {
        displayActivity.scheduledStart = new Date(newStart);
        displayActivity.scheduledEnd   = new Date(newEnd);
      }
      await this.activityService.upsertMeetingsOfflineData(activity);
      // publishActivityEvent is called internally by upsertMeetingsOfflineData — don't call it again
      this.notificationService.notify(
        this.translate.instant('RESCHEDULED_PENDING_SYNC'),
        'Drag Reschedule', 'top', ToastStyle.INFO,
      );
    }
  }

  public async updateappConfigFields(
    activity: AppointmentActivity,
    appConfigFields: Array<ConfiguredFields>,
    updateMeetingType: boolean = false
  ) {
    let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.PATCH_MEETING_V2;

    url = url.replace("{activity_id}", activity.ID);

    let requestBody = {
      'appconfigfields': [...appConfigFields]
    };

    let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
    headers.headers = headers.headers.set(
      "X-PositionId",
      this.authenticationService.user.xPositionID
    );
    try {
      let response = await this.http
        .patch(url, requestBody, headers)
        .toPromise();
      await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity as AppointmentActivity, true);
      this.activityService.publishActivityEvent({ action: "Update", activity: activity });
      this.logService.logDebug(response);


    } catch (e) {
      this.errorHandler.handleError(e);
      if (updateMeetingType) {
        return Promise.reject(e);
      }
    }
  }

  public async updateActivityLookupFields(
    activity: AppointmentActivity,
    appconfiglookupfields: UpdateTypeAndSubTypeActivityPayLoad,
    updateMeetingType: boolean = false
  ) {
    const hasOfflineData = this.activityService.hasOfflineMeetingData(activity.ID);

    // We check if there's any existing offline data for this meeting
    if (!this.deviceService.isOffline && !hasOfflineData) {
      let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.PATCH_MEETING_V2;

      url = url.replace("{activity_id}", activity.ID);

      let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
      headers.headers = headers.headers.set(
        "X-PositionId",
        this.authenticationService.user.xPositionID
      );
      try {
        let response = await this.http
          .patch(url, appconfiglookupfields.getRequestBody(), headers)
          .toPromise();
        this.logService.logDebug(response);
        if (response) {
          await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity as AppointmentActivity, true);
        }
      } catch (e) {
        this.errorHandler.handleError(e);
        if (updateMeetingType) {
          return Promise.reject(e);
        }
      }
    } else {
      // Offline or has pending offline data — update local DB only
      try {
        await this.activityService.upsertMeetingsOfflineData(activity as AppointmentActivity);
      } catch (error) {
        console.error('updateMeeting: ', error);
        if (updateMeetingType) {
          return Promise.reject(error);
        }
      }
    }
  }

  public async updateActivityTypeAndActivitySubType(activity: AppointmentActivity | PhoneActivity, payload, activitytypecode: ActivityTypeCodeRaw, entity: string, disableLoader = false) {
    if (!disableLoader) {
      await this.uiService.displayLoader();
    }
    const previousInstance = cloneDeep(this.activityService.selectedActivity);
    const hasOfflineData = activity instanceof AppointmentActivity ? this.activityService.hasOfflineMeetingData(activity.ID) : this.activityService.hasOfflinePhoneCallData(activity.ID);
    let agendaActivity = this.activityService.getActivityByID(this.activityService.selectedActivity.ID);
    if (isEqual(entity, "indskr_activitytype")) {
      agendaActivity.activityTypeName = payload.activityTypeName;
      agendaActivity.indskr_activitytype = payload.indskr_activitytype;
      this.activityService.updateSelectedActivityProps({
        activityTypeName: payload.activityTypeName,
        indskr_activitytype: payload.indskr_activitytype,
      });
    }
    agendaActivity.activitySubTypeName = payload.activitySubTypeName;
    agendaActivity.indskr_activitysubtype = payload.indskr_activitysubtype;
    this.activityService.updateSelectedActivityProps({
      activitySubTypeName: payload.activitySubTypeName,
      indskr_activitysubtype: payload.indskr_activitysubtype,
    });
    if (payload.hasOwnProperty('subject')) {
      agendaActivity.subject = payload['subject'];
      this.activityService.updateSelectedActivityProps({ subject: payload['subject'] });
    }
    
    if (this.deviceService.isOffline || hasOfflineData) {
      try {
        if (isEqual(activitytypecode, ActivityTypeCodeRaw.Appointment)) {
          await this.activityService.upsertMeetingsOfflineData(activity as AppointmentActivity)
        } else {
          await this.activityService.upsertPhoneCallOfflineData(activity as PhoneActivity);
        }
        this.logService.logDebug("Offline --> Updated activity type/sub type successfully");
      } catch (error) {
        this.activityService.selectedActivity = agendaActivity = previousInstance;
        console.error('error occurred while updating activity/subtype in db: ', error);
      }
    } else {
      let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
      headers.headers = headers.headers.set("X-PositionId", this.authenticationService.user.xPositionID);

      if (activitytypecode === ActivityTypeCodeRaw.Appointment) {
        const v2Url = (this.authenticationService.userConfig.activeInstance.entryPointUrl
          + Endpoints.meeting.PATCH_MEETING_V2).replace('{activity_id}', activity.ID);
        const v2Body = {
          indskr_activitytype:    payload.indskr_activitytype    ?? null,
          indskr_activitysubtype: payload.indskr_activitysubtype ?? null,
          ...(payload.subject != null ? { subject: payload.subject } : {}),
        };
        try {
          await this.http.patch(v2Url, v2Body, headers).toPromise();
          this.logService.logDebug("V2: Updated activity type/sub type successfully");
          await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity, true);
        } catch (e) {
          this.activityService.selectedActivity = agendaActivity = previousInstance;
          this.errorHandler.handleError(e);
        }
      } else {
        // V1: phone-call and other entity types still use the legacy endpoint.
        let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.activites.UPDATE_ACTIVITY_TYPE_SUB_TYPE;
        url = url.replace("{entityName}", activitytypecode);
        url = url.replace("{activityId}", activity.ID);
        try {
          const response = await this.http.patch(url, payload, headers).toPromise();
          this.logService.logDebug("Updated activity type/sub type successfully");
          await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity, true);
        } catch (e) {
          this.activityService.selectedActivity = agendaActivity = previousInstance;
          this.errorHandler.handleError(e);
        }
      }
    }
    if (!disableLoader) {
      this.uiService.dismissLoader();
    }
  }

  public async updateMeetingSentiment(
    activity: Activity,
    payload: Object
  ) {
    let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.PUT_MEETING.replace('{activity_id}', activity.ID);

    let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
    headers.headers = headers.headers.set(
      "X-PositionId",
      this.authenticationService.user.xPositionID
    );
    try {
      let response = await this.http
        .put(url, payload, headers)
        .toPromise();
      this.logService.logDebug(response);
      if (payload.hasOwnProperty('activityResources') || payload.hasOwnProperty('activityPresentations'))
        await this.activityService.removeOfflineMeetingPres(activity as AppointmentActivity);
    } catch (e) {
      this.errorHandler.handleError(e);

    }
  }


  /**
   * Returns the meeting's Foundry conversation id. Local-first: uses the value
   * already on the activity; if absent, fetches it directly from Dynamics
   * (bypassing sync) and, when found, persists it back to the local DB.
   */
  public async resolveMeetingConversationId(activity: AppointmentActivity): Promise<string | null> {
    if (!activity?.ID) return null;
    if (activity.conversationId) return activity.conversationId;
    if (this.deviceService.isOffline || this.deviceService.isDeviceRealOffline) return null;
    try {
      const record: any = await this.dynamics.retrieve(activity.ID, 'appointments', ['indskr_conversationid']);
      const fetched: string | null = record?.indskr_conversationid ?? null;
      if (fetched) {
        activity.conversationId = fetched;
        await this.activityService.upsertMeetingsOfflineData(activity);
      }
      return fetched;
    } catch (error) {
      console.error('resolveMeetingConversationId: ', error);
      return null;
    }
  }

  /**
   * Persists a newly created conversation id for the meeting: sets it on the
   * activity, saves to the local DB, and writes to Dynamics with a simple
   * direct PATCH (bypasses the meeting update/MSE flow). PATCH is skipped offline.
   */
  public async persistMeetingConversationId(activity: AppointmentActivity, conversationId: string): Promise<void> {
    if (!activity?.ID || !conversationId) return;
    activity.conversationId = conversationId;
    await this.activityService.upsertMeetingsOfflineData(activity);
    if (this.deviceService.isOffline || this.deviceService.isDeviceRealOffline) return;
    try {
      await this.dynamics.update(activity.ID, 'appointments', { indskr_conversationid: conversationId });
    } catch (error) {
      console.error('persistMeetingConversationId: ', error);
    }
  }

  /**
   * Maps AI-suggested key messages onto the meeting's product list: selects each
   * product key message whose name matches an accepted suggestion (and its parent
   * product), mirroring the retired Call Notes Assistant. Returns true if anything
   * was selected. Caller persists via updateMeetingProductKeyMessages.
   */
  public applyAiKeyMessages(activity: AppointmentActivity, keyMessages: MeetingSummaryKeyMessage[]): boolean {
    const accepted = new Set(
      (keyMessages ?? []).map(k => k.key_message?.trim().toLowerCase()).filter(Boolean),
    );
    if (!accepted.size) return false;
    let changed = false;
    for (const product of (activity.products ?? []) as Brand[]) {
      for (const km of product.keyMessages ?? []) {
        if (!km.isAutoSelected && accepted.has(km.name?.trim().toLowerCase())) {
          km.isSelected = true;
          km.isGenieSelected = true;
          if (!product.isAutoSelected) {
            product.isSelected = true;
            product.isGenieSelected = true;
          }
          changed = true;
        }
      }
    }
    return changed;
  }

  /**
   *  Need to switch all products/key message update
   */

  public async updateMeetingProductKeyMessages(activity: AppointmentActivity, keyMsgFor: UpdateKeyMessagesFor = { products: true, indications: false, diseaseAreas: false }) {
    let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.UPDATE_MEETING.replace('{activity_id}', activity.ID);

    let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
    headers.headers = headers.headers.set(
      "X-PositionId",
      this.authenticationService.user.xPositionID
    );

    try {

      let payload = {
        activityProducts: [],
        activityProductIndications: [],
        activityDiseaseAreas: [],
      };
      if (keyMsgFor.products) {
        const productsBody = activity.productsDTO;
        productsBody.push(...activity.proceduresDTO);
        payload.activityProducts = productsBody;
        this.events.publish('activityproductkeymessagesupdated', this.activityService.selectedActivity.products);
      } else {
        delete payload.activityProducts;
      }
      if (keyMsgFor.diseaseAreas) {
        let daobj = [];
        activity['activityDiseaseAreas'].forEach((obj, idx) => {
          if (obj.isSelected) {
            daobj.push({
              "indskr_diseaseareaid": obj.indskr_diseaseareaid,
              "indskr_sequence": obj.indskr_sequence ? obj.indskr_sequence : idx + 1,
              "indskr_automaticallyselected": obj.indskr_automaticallyselected,
              "indskr_name": obj.indskr_name,
            });
          }
        });
        payload.activityDiseaseAreas = daobj;
      } else {
        delete payload.activityDiseaseAreas;
      }
      if (keyMsgFor.indications) {
        let piobj = [];
        activity['activityProductIndications'].forEach((obj, idx) => {
          if (obj.isSelected || obj.indskr_automaticallyselected) {
            let pi = {
              "productIndicationId": obj.productIndicationId,
              "indskr_sequence": obj.indskr_sequence ? obj.indskr_sequence : idx + 1,
              "indskr_automaticallyselected": obj.indskr_automaticallyselected,
              "indskr_name": obj.indskr_name,
              "activityProductIndicationKeyMessages": [],
            };
            if (obj.activityProductIndicationKeyMessages) {
              obj.activityProductIndicationKeyMessages.forEach((obj2, idx2) => {
                if (obj2.isSelected || obj2.indskr_automaticallyselected) {
                  pi.activityProductIndicationKeyMessages.push({
                    "indskr_keymessageid": obj2.indskr_keymessageid,
                    "indskr_automaticallyselected": obj2.indskr_automaticallyselected,
                    "indskr_name": obj2.indskr_name,
                  });
                }
              });
            }
            piobj.push(pi);
          }
        });
        payload.activityProductIndications = piobj;
      } else {
        delete payload.activityProductIndications
      }

      let csobj = this._populateContactSentimentKeyMessages(activity as AppointmentActivity);
      if (csobj && Array.isArray(csobj) && csobj.length > 0) {
        payload['contactAttendees'] = csobj;
      }

      // Fix OMNI-56959: Save offline data FIRST to ensure UI state is preserved if app is killed during server sync
      try {
        await this.activityService.upsertMeetingsOfflineData(activity);
      } catch (e) {
        console.error('Caught error trying to save products and key messages offline', e);
        // If offline save fails, still attempt server sync but log the error
      }

      // Then sync to server
      let response = await this.http
        .put(url, payload, headers) // send only the required payload
        .toPromise();
      this.logService.logDebug(response);
    } catch (e) {
      // If server sync fails, offline data is already saved
      // Background upload will retry the sync later
      this.errorHandler.handleError(e);
      this.notificationService.notify(
        this.translate.instant('XPERIENCES_ERROR'),
        'Activity Detail',
        'top',
        ToastStyle.DANGER,
      );
      throw e;
    }
  }

  /**
   * PATCH-based delta update for product key messages.
   * Sends only added/removed/modified/reorder changes instead of the full product list.
   */
  public async patchMeetingProducts(activityId: string, delta: any): Promise<any> {
    const url = this.authenticationService.userConfig.activeInstance.entryPointUrl
      + Endpoints.meeting.PATCH_MEETING_PRODUCTS.replace('{activity_id}', activityId);

    let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
    headers.headers = headers.headers.set('X-PositionId', this.authenticationService.user.xPositionID);

    const response = await this.http.put(url, delta, headers).toPromise();
    return response;
  }

  public async updateMeetingProcedures(activity: AppointmentActivity): Promise<boolean> {
    let isSuccess: boolean = true;
    let loader = await this.loadingCtrl.create();
    loader.present();
    let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.UPDATE_MEETING_PRODUCTS.replace('{activity_id}', activity.ID);

    let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
    headers.headers = headers.headers.set(
      "X-PositionId",
      this.authenticationService.user.xPositionID
    );

    try {
      const requestBody = activity.proceduresDTO;
      requestBody.push(...activity.productsDTO);
      let response = await this.http
        .put(url,requestBody , headers) // send only the required payload
        .toPromise();
      this.logService.logDebug(response);
      loader.dismiss();
    } catch (e) {
      isSuccess = false;
      this.errorHandler.handleError(e);
      loader.dismiss();
    }

    try { // I/O operations needs to be wrap in a try and catch block
      this.activityService.upsertMeetingsOfflineData(activity); // offline saving
      loader.dismiss();
    } catch (e) {
      console.error('Caught error trying to save products and key messages offline', e);
      isSuccess = false;
      loader.dismiss();
    }
    return isSuccess;
  }

  public async updateMeetingSupportingMaterials(activity: AppointmentActivity): Promise<boolean> {
    let isSuccess: boolean = true;
    let loader = await this.loadingCtrl.create();
    loader.present();
    let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.UPDATE_MEETING_SUPPORTING_MATERIALS.replace('{activity_id}', activity.ID);
    let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
    headers.headers = headers.headers.set(
      "X-PositionId",
      this.authenticationService.user.xPositionID
    );

    try {
      const requestBody = activity.activitySupportingMaterialsDTO;
      let response = await this.http
        .put(url,requestBody , headers) // send only the required payload
        .toPromise();
      this.logService.logDebug(response);
      loader.dismiss();
    } catch (e) {
      isSuccess = false;
      this.errorHandler.handleError(e);
      loader.dismiss();
    }

    try { // I/O operations needs to be wrap in a try and catch block
      this.activityService.upsertMeetingsOfflineData(activity); // offline saving
      loader.dismiss();
    } catch (e) {
      console.error('Caught error trying to save products and key messages offline', e);
      isSuccess = false;
      loader.dismiss();
    }
    return isSuccess;
  }

  public async updateKitBookings(activity: AppointmentActivity, setBookings): Promise<boolean> {
    let isSuccess: boolean = true;
    let loader = await this.loadingCtrl.create();
    loader.present();
    const kitBookingId: string | null = Array.isArray(setBookings) && setBookings.length > 0
      ? (setBookings[0]?.indskr_kitbooking ?? setBookings[0])
      : null;
    let url: string = (this.authenticationService.userConfig.activeInstance.entryPointUrl
      + Endpoints.meeting.PATCH_MEETING_V2).replace('{activity_id}', activity.ID);

    let headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
    headers.headers = headers.headers.set(
      "X-PositionId",
      this.authenticationService.user.xPositionID
    );

    try {
      let response = await this.http
        .patch(url, { indskr_kitbooking: kitBookingId }, headers)
        .toPromise();
      this.logService.logDebug(response);
      loader.dismiss();
    } catch (e) {
      isSuccess = false;
      this.errorHandler.handleError(e);
      loader.dismiss();
    }

    try { // I/O operations needs to be wrap in a try and catch block
      this.activityService.upsertMeetingsOfflineData(activity); // offline saving
      loader.dismiss();
    } catch (e) {
      console.error('Caught error trying to save products and key messages offline', e);
      isSuccess = false;
      loader.dismiss();
    }
    return isSuccess;
  }

  async validateMeetingCompletionDatetime(activity: AppointmentActivity) {
    if (!activity || !activity.scheduledStart || !activity.scheduledEnd) {
      return;
    }

    try {
      let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.VALIDATE_RETROACTIVE_COMPLETION_LIMIT;
      const headers = Endpoints.headers.content_type.json;
      const { timeZone } = Intl?.DateTimeFormat()?.resolvedOptions();
      if (timeZone) {
        headers.headers = headers.headers.set(
          'X-Zone-Id',
          timeZone,
        );
      }

      // Set start & end timestamp req params
      url = url.replace("{startTimestamp}", activity.scheduledStart.getTime() + '');
      url = url.replace("{endTimestamp}", activity.scheduledEnd.getTime() + '');

      // Get retroactive limit values
      const retroactiveMeetingCompletionLimitInDays = !isNaN(this.authenticationService.user.buConfigs['indskr_retroactivemeetingcompletionlimitindays'])
        ? this.authenticationService.user.buConfigs['indskr_retroactivemeetingcompletionlimitindays']
        : null;
      const retroactiveMeetingCompletionLimitInHours = !isNaN(this.authenticationService.user.buConfigs['indskr_retroactivemeetingcompletionlimit'])
        ? this.authenticationService.user.buConfigs['indskr_retroactivemeetingcompletionlimit']
        : null;

      // Set limit value req param
      if (
        retroactiveMeetingCompletionLimitInDays !== null
        && retroactiveMeetingCompletionLimitInDays >= 0
      ) {
        url = url + '&retroLimit=' + retroactiveMeetingCompletionLimitInDays
      } else if (
        retroactiveMeetingCompletionLimitInHours !== null
        && retroactiveMeetingCompletionLimitInHours > 0
      ) {
        url = url + '&retroLimitInHours=' + retroactiveMeetingCompletionLimitInHours
      } else {
        // If retroactive completion limit config does not exist, no need to validate
        return;
      }

      await this.http.get(url, headers).toPromise();
    } catch (error) {
      // Meeting completion date validation error. Throw to upper caller
      throw error;
    }
  }

  public async updateMeetingStatus(activity: AppointmentActivity, status: MeetingStatus, dateCompleted?: number, isDeleted?: boolean, extraPayload?: any, selfClaim?: boolean, bypassRetroLimitCheck = false) {

    const stateCode = this.getActivityStateCode(status);
    let subject = activity.subject;
    if (this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)) {
      if (!activity.indskr_shortcall && !activity.indskr_kitbooking && dateCompleted && !this.secondaryInfoService.isAppointmentSecInfoConfigured) {
        subject = this.getMeetingSubject(activity);
      } else if (this.secondaryInfoService.isAppointmentSecInfoConfigured) {
        subject = this.secondaryInfoService.getSecondaryInfoFormatedTextForAppointment(this.activityService.selectedActivity, SecondaryInfoEntityName.Appointment);
      }
    }
      if (this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)) {
        if (!activity.indskr_shortcall && !activity.indskr_kitbooking && dateCompleted && !this.secondaryInfoService.isAppointmentSecInfoConfigured) {
          subject = this.getMeetingSubject(activity);
        } else if (this.secondaryInfoService.isAppointmentSecInfoConfigured) {
          subject = this.secondaryInfoService.getSecondaryInfoFormatedTextForAppointment(this.activityService.selectedActivity, SecondaryInfoEntityName.Appointment);
        }
      }
      // Prevent account visit offline request
      const accountVisitRecordResponse = this.activityService.accountVisitRecordCheck(activity);
      if (this.activityService.accountVisitOfflineCheck(
        accountVisitRecordResponse,
        true,
      )) {
        return Promise.reject(new Error('updateMeetingStatus: offline attempt for account visit'));
      }

      if (this.deviceService.isOffline || this.activityService.hasOfflineMeetingData(activity.ID)) {
        try {
          const idx = this.activityService.activities.findIndex(item => item.ID === activity.ID);

          this.activityService.activities[idx].state = stateCode;
          if (status === MeetingStatus.CANCELED) {
            this.activityService.activities[idx].status = 4;
            activity.status = 4;
          }
          if (dateCompleted) {
            this.activityService.activities[idx].omnip_datecompleted = dateCompleted.toString();
            activity.omnip_datecompleted = dateCompleted.toString();
            activity.subject = subject;
            if (!isEmpty(this.activityService.selectedActivity.indskr_activitytype)) {
              activity.indskr_activitytype = this.activityService.selectedActivity.indskr_activitytype;
              if (!isEmpty(this.activityService.selectedActivity.indskr_activitysubtype)) {
                activity.indskr_activitysubtype = this.activityService.selectedActivity.indskr_activitysubtype;
              }
            }
          }
          if (selfClaim)
            activity.indskr_selfclaimbyuseronappttimemodification = selfClaim;
          activity.state = stateCode;
          if (isDeleted == true) {
            activity.deleted = true;
          }
          await this.activityService.upsertMeetingsOfflineData(activity);
          console.log('updateMeetingStatus offline update DB success: ');
          if (MeetingStatus.COMPLETED === status) {
            await this.globalUtility.updateInteraction(activity.contacts, activity.accounts, 'Meetings');
          }
          return Promise.resolve();
        }
        catch (err) {
          return Promise.reject(err);
        }

      } else {
        let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
          Endpoints.meeting.UPDATE_MEETING_STATUS.replace("{activity_id}", activity.ID);

        //Added indskr_meetingcontentreasonsid for No Detailing in a Meeting
        let requestBody = {
          statuscode: status,
          omnip_datecompleted: dateCompleted,
          subject: subject,
          indskr_meetingcontentreasonsid: activity.indskr_meetingcontentreasonsid,
          scheduledstart: activity.scheduledStart?.getTime(),
          scheduledend: activity.scheduledEnd?.getTime(),
          indskr_reasonforcancellation: activity.indskr_reasonforcancellation,
          indskr_cancellationreasonother: activity.indskr_cancellationreasonother
        };
        if (extraPayload) {
          requestBody = { ...requestBody, ...extraPayload }
        }
        if (selfClaim) {
          requestBody['indskr_selfclaimbyuseronappttimemodification'] = selfClaim;
        }
        if (!isEmpty(this.activityService.selectedActivity?.indskr_activitytype)) {
          requestBody['indskr_activitytype'] = this.activityService.selectedActivity.indskr_activitytype;
          if (!isEmpty(this.activityService.selectedActivity?.indskr_activitysubtype)) {
            requestBody['indskr_activitysubtype'] = this.activityService.selectedActivity.indskr_activitysubtype;
          }
        }
        try {
          const headers = Endpoints.headers.content_type.json;
          if (!bypassRetroLimitCheck) {
            const { timeZone } = Intl?.DateTimeFormat()?.resolvedOptions();
            if (timeZone) {
              headers.headers = headers.headers.set(
                'X-Zone-Id',
                timeZone,
              );
            }
            const retroactiveMeetingCompletionLimitInDays = !isNaN(this.authenticationService.user.buConfigs['indskr_retroactivemeetingcompletionlimitindays'])
              ? this.authenticationService.user.buConfigs['indskr_retroactivemeetingcompletionlimitindays']
              : null;
            const retroactiveMeetingCompletionLimitInHours = !isNaN(this.authenticationService.user.buConfigs['indskr_retroactivemeetingcompletionlimit'])
              ? this.authenticationService.user.buConfigs['indskr_retroactivemeetingcompletionlimit']
              : null;
            if (
              retroactiveMeetingCompletionLimitInDays !== null
              && retroactiveMeetingCompletionLimitInDays >= 0
            ) {
              url = url + '?retroLimit=' + retroactiveMeetingCompletionLimitInDays;
              if (selfClaim) {
                url += '&selfClaim=' + true;
              }
            } else if (
              retroactiveMeetingCompletionLimitInHours !== null
              && retroactiveMeetingCompletionLimitInHours > 0
            ) {
              url = url + '?retroLimitInHours=' + retroactiveMeetingCompletionLimitInHours;
              if (selfClaim) {
                url += '&selfClaim=' + true;
              }
            } else if (selfClaim) {
              url += '?selfClaim=' + true;
            }
          } else {
            if (selfClaim) {
              url += '?selfClaim=' + true;
            }
          }

          await this.http.put(url, requestBody, headers).toPromise();

          if (MeetingStatus.COMPLETED === status) {
            await this.globalUtility.updateInteraction(activity.contacts, activity.accounts, 'Meetings');
          }
          let activityToUpdate = this.activityService.getActivityByID(activity.ID);

          if (!activityToUpdate) {
            console.error('updateMeetingStatus: ', activity);
            activityToUpdate = activity;
          }

          activityToUpdate.state = stateCode;     //update activities array
          if (status === MeetingStatus.OPEN) {
            activityToUpdate.status = 1;
          }
          if (status === MeetingStatus.CANCELED) {
            activityToUpdate.status = 4;
          }
          if (dateCompleted) {
            activityToUpdate.omnip_datecompleted = dateCompleted.toString();
            activityToUpdate.omnip_datecompleted = activity.omnip_datecompleted = dateCompleted.toString();
            this.activityService.updateSelectedActivityProps({ subject });
          }

          console.log('updateMeetingStatus: update service success: ');
          try {
            activity.state = stateCode;
            await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity, true);
            console.log('updateMeetingStatus: update DB success: ');
          } catch (error) {
            console.warn('updateMeetingStatus: db update error: ', error);
            // TODO
          }
          return Promise.resolve();
        }
        catch (err) {
          console.error('updateMeetingStatus: ', err);

          // Meeting completion date validation error. Throw to upper caller
          const errorInfo = (err.hasOwnProperty('error')) ? err.error : err;
          if (errorInfo?.errorCode?.includes('ERR_IO_ME')) {
            return Promise.reject(err);
          }
          // if network call failed
          let activityToUpdate = this.activityService.getActivityByID(activity.ID);

          if (dateCompleted) {
            activityToUpdate.omnip_datecompleted = dateCompleted.toString();
            activityToUpdate.omnip_datecompleted = activity.omnip_datecompleted = dateCompleted.toString();
            this.activityService.updateSelectedActivityProps({ subject });
          }

          activityToUpdate.state = stateCode;     //update activities array
          if (status === MeetingStatus.COMPLETED) {
            activityToUpdate.status = 1;
          }

          this.activityService.upsertMeetingsOfflineData(activity, true, true);
          return Promise.reject(err);
        }
      }
  }

  public getMeetingSubject(activity) {
    let subject: string = this.translate.instant('MEETING');
    let subPrefix = ` - ${subject}`
    if (this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)) { //added for auto subject name suffixed with rep's name if she has auto subject FA.
      subPrefix = ' - '.concat([subject, activity.activityTypeName, this.authenticationService.user.displayName].filter(Boolean).join(' - '));
    }
    const isAcinoBaseUser = this.authenticationService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT);
    if (isAcinoBaseUser) {
      subject = `${activity.activityTypeName ? activity.activityTypeName + ' ' : ''}`+this.translate.instant('VISIT');
    }
    switch (activity.contacts.length) {
      case 0:
        subject = activity.subject
        break;
      case 1:
        subject = (activity.contacts[0].fullname ? activity.contacts[0].fullname : ((!isEmpty(activity.contacts[0].firstName)) ? this.contactService.getFullNameForContactDisplaySequence(activity.contacts[0]) : activity.contacts[0].lastName)) + subPrefix;
        if (isAcinoBaseUser) {
          subject = `${activity.activityTypeName ? activity.activityTypeName + ' ' : ''}`+this.translate.instant('VISIT') + ` - ${(!isEmpty(activity.contacts[0].firstName)) ? this.contactService.getFullNameForContactDisplaySequence(activity.contacts[0]) : activity.contacts[0].lastName}`;
        }
        break;
      default:
        if (activity.contacts.length > 1) {
          activity.contacts.sort((contactA, contactB): number => {
            let contactAFullName =  activity.contacts[0].fullname ? activity.contacts[0].fullname : (!isEmpty(contactA.firstName)) ? contactA.firstName + " " + contactA.lastName : contactA.lastName;
            let contactBFullName = activity.contacts[0].fullname ? activity.contacts[0].fullname : (!isEmpty(contactA.firstName)) ? contactB.firstName + " " + contactB.lastName : contactB.lastName;
            if (contactAFullName.toLowerCase() > contactBFullName.toLowerCase())
              return 1;
            if (contactAFullName.toLowerCase() < contactBFullName.toLowerCase())
              return -1;

            return 0;
          });
          subject =(activity.contacts[0].fullname ? activity.contacts[0].fullname :((!isEmpty(activity.contacts[0].firstName)) ? this.contactService.getFullNameForContactDisplaySequence(activity.contacts[0]) : activity.contacts[0].lastName)) + ' + ' + (activity.contacts.length - 1) + subPrefix;
          if (isAcinoBaseUser) {
            subject = `${activity.activityTypeName ? activity.activityTypeName + ' ' : ''}`+this.translate.instant('VISIT') + ` - ${activity.contacts[0].fullName ? activity.contacts[0].fullName : (!isEmpty(activity.contacts[0].firstName)) ? this.contactService.getFullNameForContactDisplaySequence(activity.contacts[0]) : activity.contacts[0].lastName}`;
          }
        }
    }
    return subject;
  }

  public getActivityStateCode(status: MeetingStatus) {
    switch (status) {
      case MeetingStatus.OPEN:
        return 0;
      case MeetingStatus.COMPLETED:
        return 1;
      case MeetingStatus.CANCELED:
        return 2;
      case MeetingStatus.SCHEDULED:
        return 3;
      default:
        return 0;
    }
  }


  /**
   * Endpoint access to associate accounts to an appointment activity
   *
   * @param {AppointmentActivity} activity
   * @memberof MeetingDataService
   */
  public async addAccountsToMeeting(activity: AppointmentActivity) {
    // ! need to add try catch block and in catch block revert account selection if GPS FA enabled

    const url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
      Endpoints.meeting.PATCH_MEETING_ACCOUNTS_V2.replace('{activity_id}', activity.ID);

    // Compute delta vs raw activity accounts stored on the activity
    const rawAccounts: any[] = activity._raw_activityAccounts || [];
    const rawAccountIds = new Set(rawAccounts.map((r: any) => r.indskr_accountid));
    const currentAccountIds = new Set(activity.accounts.map(a => a.id));

    const added = activity.accounts
      .filter(a => !rawAccountIds.has(a.id))
      .map(a => ({ accountId: a.id, accountName: a.accountName }));

    const removed = rawAccounts
      .filter((r: any) => !currentAccountIds.has(r.indskr_accountid))
      .map((r: any) => r.indskr_activityaccountid)
      .filter(Boolean);

    const deltaPayload = { added, removed };

    try {
      const response = await this.http.patch(url, deltaPayload).toPromise();
      console.log(response);
      for (let account of activity.accounts) {
        if (account.isUsedInOneTimeMeeting) {
          this.dynamics.dwa.updateSingleProperty(account.id, "accounts", { omniveev_isusedinonetimemeeting: true });
        }
      }
    } catch (error) {
      console.error('addAccountsToMeeting: ', error);
      await this.activityService.upsertMeetingsOfflineData(activity, true, true);
    }
  }

  /**
   * Adds related items (opportunities, account plans, or events) to a meeting.
   * Shared implementation for addOpportunitiesToMeeting, addAccountPlansToMeeting, addEventsToMeeting.
   */
  private async _addRelatedItemsToMeeting(
    activity: AppointmentActivity,
    payload: any,
    endpoint: string
  ): Promise<boolean | void> {
    const hasOfflineData = this.activityService.hasOfflineMeetingData(activity.ID);
    if (!this.deviceService.isOffline && !hasOfflineData) {
      let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
        endpoint.replace("{activity_id}", activity.ID);
      let response = await this.http.put(url, payload).toPromise();
      console.log(response);
      if (response) {
        await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity as AppointmentActivity, true);
        return true;
      }
    } else {
      if (payload) {
        await this.activityService.upsertMeetingsOfflineData(activity as AppointmentActivity);
      }
    }
  }

  public async addOpportunitiesToMeeting(activity: AppointmentActivity, payload: any) {
    return this._addRelatedItemsToMeeting(activity, payload, Endpoints.meeting.ADD_OPPORTUNITIES_TO_MEETING);
  }

  public async addAccountPlansToMeeting(
    activity: AppointmentActivity,
    payload: string[] | { accountPlansAdded: string[]; accountPlansRemoved: string[] }
  ) {
    const hasOfflineData = this.activityService.hasOfflineMeetingData(activity.ID);
    if (!this.deviceService.isOffline && !hasOfflineData) {
      const body = Array.isArray(payload)
        ? { accountPlansAdded: payload, accountPlansRemoved: [] }
        : payload;
      const url = (this.authenticationService.userConfig.activeInstance.entryPointUrl
        + Endpoints.meeting.PATCH_MEETING_V2).replace('{activity_id}', activity.ID);
      const headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
      try {
        const response = await this.http.patch(url, body, headers).toPromise();
        if (response) {
          await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity as AppointmentActivity, true);
          return response; // carries createdAccountPlans[]{accountPlanId, activityMeetingId}
        }
      } catch (error) {
        console.error('addAccountPlansToMeeting V2:', error);
        this.errorHandler.handleError(error);
      }
    } else if (payload) {
      await this.activityService.upsertMeetingsOfflineData(activity as AppointmentActivity);
    }
  }

  public async addEventsToMeeting(activity: AppointmentActivity, payload: any) {
    return this._addRelatedItemsToMeeting(activity, payload, Endpoints.meeting.ADD_EVENTS_TO_MEETING);
  }


  /**
   * Updates the appointment activity with a new presentation
   *
   * @param {Presentation} presentation
   * @param {AppointmentActivity} activity
   * @memberof MeetingDataService
   */
  public async addContentToMeeting(
    content: Array<Presentation | Resource>,
    activity: AppointmentActivity,
    updateContentToActivity = false,
  ) {
    console.log("service call add presentation and resources to meeting");

    //If offline, add to the activity object and updateOfflineMeeting on disk
    //Fuck it save offline anyways, takes a ms and loads faster


    //ToDO: Save resources in db and dynamics
    console.log("***** Meeting content  ", content);

    if (this.deviceService.isOffline || this.activityService.hasOfflineMeetingData(activity.ID)) {
      if (updateContentToActivity) {
        this.activityService.selectedActivity['presentations'] = content;
      }
      this.activityService.upsertMeetingsOfflineData(activity);
      return;
    }

    let headers = new HttpHeaders();
    headers = headers.set("X-PositionId", this.authenticationService.user.xPositionID);
    let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
      Endpoints.meeting.ADD_PRESENTATION_TO_MEETING.replace(
        "{activity_id}",
        activity.ID
      );
    let presDtoArray = [];
    for (let pres of content) {
      presDtoArray.push(pres.DTO);
    }

    try {
      await this.http.put(url, presDtoArray, { headers }).toPromise();
      await this.activityService.upsertMeetingsOfflineData(activity, false, false)
    } catch (error) {
      console.log('addContentToMeeting: ', error);
      this.activityService.upsertMeetingsOfflineData(activity, false, true);
    } finally {
      this.events.publish('contentIsAdded', content);
      if (updateContentToActivity) {
        this.activityService.selectedActivity['presentations'] = content;
      }
    }

  }
  /**
   * @shouldInsertActivityInAgenda - default true to add the activity to agenda. It can be false if activity is created form Tools 
   * Agenda can be refreshed on Tool's master page close 
   */
  async createNewMeeting(payload: InitiateMeetingPayload, contactFullName = null, isFromClone: boolean = false): Promise<AppointmentActivity | undefined> {
    const reqBody = payload.getRequestBody();

    let newMeeting: AppointmentActivity = undefined;
    const rawNewMeeting = payload.getRequestBody();

    rawNewMeeting['indskr_positionid'] = this.authenticationService.user.xPositionID;
    rawNewMeeting['statecode'] = 0;
    rawNewMeeting['statuscode'] = 1;
    rawNewMeeting['activityid'] = payload.offlineMeetingId;
    rawNewMeeting['indskr_ownerid'] = this.authenticationService.user.systemUserID;
    rawNewMeeting['indskr_ownerfullname'] = this.authenticationService.user.displayName;
    rawNewMeeting['eventId'] = payload.eventId;
    if (isFromClone) {
      reqBody["subject"] = rawNewMeeting["subject"];
      reqBody["indskr_activitytype"] = rawNewMeeting["indskr_activitytype"]; 
      reqBody["activityTypeName"] = rawNewMeeting["activityTypeName"];
      reqBody["indskr_activitysubtype"] = rawNewMeeting["indskr_activitysubtype"];
      reqBody["activitySubTypeName"] = rawNewMeeting["activitySubTypeName"];
      reqBody["indskr_coachingplan"] = rawNewMeeting["indskr_coachingplan"];
      reqBody["indskr_coachingplanname"] = rawNewMeeting["indskr_coachingplanname"];
    }
    else{
      const activityTypes = this.activityService.configuredActivityTypes(MeetingActivityTypeCode.MEETING, FormatType.HCP_MEETING);
      if (!isEmpty(activityTypes)) {
        this.logService.logDebug("Creating meeting with activity type");
        const selectedActivityType = !isEmpty(reqBody["indskr_activitytype"])
          ? activityTypes.find(at => at.indskr_activitytypeid === reqBody["indskr_activitytype"])
          : (
            reqBody["indskr_kitbooking"] && !!activityTypes.find(at => at.indskr_defaultformatforkitbooking)
              ? activityTypes.find(at => at.indskr_defaultformatforkitbooking)
              : activityTypes.find(at => at.indskr_default) || (activityTypes.some(at => at.indskr_mandatory) ? activityTypes[0] : null)
          );
        if (!isEmpty(selectedActivityType)) {
          const formattedSelectedActivityTypeName = !isEmpty(reqBody["activityTypeName"])
            ? reqBody["activityTypeName"]
            : this.localisationService.getTranslatedString(selectedActivityType.indskr_name, EntityNameForTranslation.ActivityType);
          reqBody["indskr_activitytype"] = rawNewMeeting["indskr_activitytype"] = selectedActivityType.indskr_activitytypeid;
          reqBody["activityTypeName"] = rawNewMeeting["activityTypeName"] = formattedSelectedActivityTypeName;
          if (isFromClone) {
            reqBody["subject"] = rawNewMeeting["subject"];
          } else {
            if (payload.shortCall) {
              reqBody["subject"] = rawNewMeeting["subject"] = `${reqBody.subject} - ${formattedSelectedActivityTypeName} - ${this.authenticationService.user.displayName}`;
            }
            else {
              if (this.authenticationService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT)) {
                reqBody["subject"] = rawNewMeeting["subject"] = `${formattedSelectedActivityTypeName} ${this.translate.instant('VISIT')}`;
              } 
              // % % % Ability Autoname Subject in Meeting and Procedure Log % % % //
              else if (this.secondaryInfoService.isAppointmentSecInfoConfigured) {
                reqBody["subject"] = rawNewMeeting["subject"] = `${this.translate.instant('MEETING')}`;
              }
              // % % % Ability Autoname Subject in Meeting and Procedure Log % % % //
              else if (this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)) {
                reqBody["subject"] = rawNewMeeting["subject"] = `${this.translate.instant('MEETING')} - ${formattedSelectedActivityTypeName} - ${rawNewMeeting['indskr_ownerfullname']}`;
              }  else {
                // When both MEETING_AUTO_SUBJECT and secondary info are disabled, keep the original subject
                // Do not auto-format the subject as per OMNI-53187
                if (contactFullName) {
                  reqBody["subject"] = rawNewMeeting["subject"] = `${contactFullName} - ${rawNewMeeting['subject']}`;
                }
                // Otherwise, keep the subject as-is from the payload (typically just "MEETING")
              }
            }
          }
          const activitySubTypes = this.activityService.getActivitySubTypesByActivityType(MeetingActivityTypeCode.MEETING, selectedActivityType.indskr_activitytypeid);
          if (isEmpty(reqBody["indskr_activitysubtype"]) && !isEmpty(activitySubTypes)) {
            const defaultActivitySubType = activitySubTypes.find(ast => ast.indskr_default);
            if (!isEmpty(defaultActivitySubType)) {
              reqBody["indskr_activitysubtype"] = rawNewMeeting["indskr_activitysubtype"] = defaultActivitySubType.indskr_activitysubtypeid;
              reqBody["activitySubTypeName"] = rawNewMeeting["activitySubTypeName"] = this.localisationService.getTranslatedString(defaultActivitySubType.indskr_name, EntityNameForTranslation.ActivityType);
            }
          } else if (!isEmpty(reqBody["indskr_activitysubtype"]) && isEmpty(reqBody["activitySubTypeName"])) {
            const selectedActivitySubType = activitySubTypes?.find(ast => ast.indskr_activitysubtypeid === reqBody["indskr_activitysubtype"]);
            if (!isEmpty(selectedActivitySubType)) {
              reqBody["activitySubTypeName"] = rawNewMeeting["activitySubTypeName"] = this.localisationService.getTranslatedString(selectedActivitySubType.indskr_name, EntityNameForTranslation.ActivityType);
            }
          }
        }
      }
    }

    if (payload.isSubjectFinalForCreate) {
      reqBody["subject"] = rawNewMeeting["subject"] = payload.subject;
    }
    // If upfront contacts provided (e.g. meeting started from contact-details page),
    // use the first contact for secondary-info subject generation before finalising.
    if (payload.contacts?.length && !payload.contactForCreateSubject) {
      payload.contactForCreateSubject = payload.contacts[0];
    }
    this._finalizeCreatePayloadSubject(reqBody, rawNewMeeting, payload);
    rawNewMeeting['createRequestFields'] = this._getCreateRequestFields(reqBody);

    // Embed upfront contacts into the V2 create request for a single-call round-trip.
    // When offline the contacts key is ignored by _createPendingMeeting; it only affects
    // the online _createNewMeetingReq path.
    if (payload.contacts?.length) {
      reqBody['contacts'] = payload.contacts
        .map(c => this.getContactAttendeePayload(c, true))
        .filter(Boolean);
    }
    if (this.deviceService.isNativeApp) {

      //[OMNI-6296]Pass Phone Call ActivityId to link to activity ID while creating meeting from Dynamics Call Center
      this.activityService.contactCenterActivityInputs$.subscribe((value) => {
        if (value && value.hasOwnProperty('phoneCallId')) {
          reqBody['phoneCallId'] = value['phoneCallId'];
          if (value.hasOwnProperty('contactId')) {
            //Add contact to new appointment activity
            let contact = this.contactService.getContactByID(
              value['contactId']
            );
            if (contact) {
              reqBody.subject = `${this.contactService.getFullNameForContactDisplaySequence(contact)} - Meeting`;
              this.activityService.contactCenterContactInputs$.next(contact);
            }
          }
        }
      }).unsubscribe();
      this.activityService.contactCenterActivityInputs$.next(null);

        try {
          if (this.deviceService.isOffline) {
            // Device is fully offline — create a local pending meeting immediately.
            const pendingMeeting = await this._createPendingMeeting(rawNewMeeting);
            if (pendingMeeting instanceof AppointmentActivity) {
              newMeeting = pendingMeeting;
            }
          } else {
            // Race the API call against a 3-second wall-clock timeout so that slow server
            // responses never hard-block the user.  If the timeout fires first we materialise
            // the meeting as an offline-pending record right away and let the API call finish
            // in the background.  When the server eventually responds we merge the real IDs
            // into the pending record and — if the user made further edits in the meantime —
            // silently push those changes via a targeted offline-upload, all without any
            // notification or loader.
            const MEETING_CREATION_TIMEOUT_MS = 3000;
            // Unique sentinel so we can distinguish a timed-out race from a null response.
            const TIMED_OUT = Symbol('timedOut');

            const apiCallPromise = this._createNewMeetingReq(reqBody);
            const raceResult = await Promise.race([
              apiCallPromise,
              new Promise<typeof TIMED_OUT>(resolve =>
                setTimeout(() => resolve(TIMED_OUT), MEETING_CREATION_TIMEOUT_MS)
              ),
            ]);

            if (raceResult === TIMED_OUT) {
              // Server didn't respond within 3 s — unblock the user immediately.
              console.info('[createNewMeeting] server took >3 s — creating pending offline meeting');
              const pendingMeeting = await this._createPendingMeeting(rawNewMeeting);
              if (!pendingMeeting) return;
              newMeeting = pendingMeeting;
              // Continue waiting for the API response in the background.
              // When it arrives, merge and (if needed) sync any user-made edits silently.
              apiCallPromise
                .then(res => {
                  if (res) {
                    this._handleDelayedMeetingCreationResponse(res, pendingMeeting, payload, reqBody).catch(err =>
                      console.error('[createNewMeeting] background response handler error:', err)
                    );
                  }
                })
                .catch(err => {
                  // Non-ERR_IO_ME12 errors are already reflected as the pending offline meeting
                  // sitting in the offline queue, so we only log here.
                  console.error('[createNewMeeting] background API error (after timeout):', err);
                });
            } else {
              // Fast path — server responded within the timeout window.
              const res = raceResult as MeetingCreateResponseDTO;
              if (!res) return;
              if (payload.eventId)
                await this.msEventService.associateEvent(payload.eventId, res.activityId).then(() => res).catch(e => res);
              // upsert offline data
              rawNewMeeting['indskr_isofflinemeeting'] = true;
              newMeeting = new (rawNewMeeting.location === 'LiveMeet' ? LiveMeetActivity : AppointmentActivity)(rawNewMeeting);
              this._setCreateRequestFields(newMeeting, reqBody);
              const success: boolean = await this.activityService.upsertMeetingsOfflineData(newMeeting);
              if (!success) return;
              // creation response is back from server.
              await this._handleMeetingCreationResponse(res, newMeeting);
              // Populate contacts cached on the meeting object when they were embedded upfront
              if (payload.contacts?.length && res.createdContacts?.length) {
                this._applyUpfrontContacts(newMeeting, payload.contacts, res.createdContacts);
              }
            }
          }
        } catch (httpError) {
          console.error('!shouldWaitForMeetingCreationResponse: createNewMeeting: ', httpError);
          const errorInfo = (httpError.hasOwnProperty('error')) ? httpError.error : httpError;
          if (errorInfo.errorCode == "ERR_IO_ME12") {
            this.isErrorStartDateCreateMeeting = true;
            const restrictMeetingCreationForPastDateAndTimeFlag = this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.RESTRICT_MEETING_CREATION_FOR_PAST_DATE_AND_TIME) as boolean;
            if (restrictMeetingCreationForPastDateAndTimeFlag) {
              this.notificationService.notify(
                this.translate.instant('CAN_NOT_SCHEDULE_MEETING_FOR_PAST_DATE_AND_TIME'),
                'Date Time Picker','top',ToastStyle.DANGER
              );
            } else {
              this.notificationService.notify(this.translate.instant(
                'NEW_ACTIVITY_TOAST_CAN_NOT_SCHEDULE_MEETING',
                { maxMeetingStartDays: this.authenticationService.user.maxMeetingStartDays }),
                'Date Time Picker', 'top', ToastStyle.DANGER
              );
            }
            return;
          } else {
            // upsert offline data
            rawNewMeeting['indskr_isofflinemeeting'] = true;
            newMeeting = new (rawNewMeeting.location === 'LiveMeet' ? LiveMeetActivity : AppointmentActivity)(rawNewMeeting);
            this._setCreateRequestFields(newMeeting, reqBody);
            const success: boolean = await this.activityService.upsertMeetingsOfflineData(newMeeting);
            if (!success) return;
          }
        }
    } else {
      try {
        const response = this.deviceService.isOffline
          ? await this._createPendingMeeting(rawNewMeeting)
          : await this._createNewMeetingReq(reqBody);
        if (response instanceof AppointmentActivity) {
          newMeeting = response;
        } else if (response && response.activityId) {
          if (!this.deviceService.isOffline && this.authenticationService.hasFeatureAction(FeatureActionsMap.TEAMS_MEETING)) {
            this.createTeamsMeeting(reqBody, response.activityId);
          }
          rawNewMeeting['indskr_meetingurl'] = response.indskr_meetingurl;
          rawNewMeeting['activityid'] = response.activityId;
          rawNewMeeting['lastUpdatedTime'] = new Date().getTime();
          rawNewMeeting['_id'] = DB_KEY_PREFIXES.MEETING_ACTIVITY + response.activityId;

          newMeeting = new AppointmentActivity(rawNewMeeting);
          this._setCreateRequestFields(newMeeting, reqBody);
          // Populate contacts cached on the meeting object when they were embedded upfront
          if (payload.contacts?.length && response.createdContacts?.length) {
            this._applyUpfrontContacts(newMeeting, payload.contacts, response.createdContacts);
          }
          // Persist to PouchDB so the meeting survives a page reload.
          // The native path does this inside _handleMeetingCreationResponse; this web/non-native
          // path previously had no equivalent write, causing the meeting to disappear on reload
          // until the next delta sync restored it from the server.
          await this.disk.updateOrInsertActivityToActivityDetailRawDocument(newMeeting, false);
          // Subscribe to ws
          this.events.publish('ws:subscribeToMeetingTopic', newMeeting);
        }
      } catch (httpError) {
        console.error('createNewMeeting: ', httpError);
        const errorInfo = (httpError.hasOwnProperty('error')) ? httpError.error : httpError;
        if (errorInfo.errorCode == "ERR_IO_ME12") {
          this.isErrorStartDateCreateMeeting = true;
          const restrictMeetingCreationForPastDateAndTimeFlag = this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.RESTRICT_MEETING_CREATION_FOR_PAST_DATE_AND_TIME) as boolean;
            if (restrictMeetingCreationForPastDateAndTimeFlag) {
              this.notificationService.notify(
                this.translate.instant('CAN_NOT_SCHEDULE_MEETING_FOR_PAST_DATE_AND_TIME'),
                'Date Time Picker','top',ToastStyle.DANGER
              );
            } else {
              this.notificationService.notify(this.translate.instant(
                'NEW_ACTIVITY_TOAST_CAN_NOT_SCHEDULE_MEETING', 
                { maxMeetingStartDays: this.authenticationService.user.maxMeetingStartDays }), 
                'Date Time Picker', 'top', ToastStyle.DANGER
              );
            } 
          return;
        }
      }
    }

    this.activityService.addActivity(newMeeting);
    return newMeeting;
  }

  /**
   * Populates {@code contacts} and {@code _raw_contactAttendees} on a freshly created meeting
   * using the list of junction records returned by the V2 POST /meetings endpoint.
   * Called only on the online path when {@code payload.contacts} was non-empty.
   */
  private _applyUpfrontContacts(
    meeting: AppointmentActivity,
    contacts: Contact[],
    createdContacts: Array<{ contactId: string; activityContactId: string }>
  ): void {
    meeting.contacts = [...contacts];
    meeting._raw_contactAttendees = createdContacts.map(c => {
      const src = contacts.find(ct => ct.ID === c.contactId);
      return {
        activityId: meeting.ID,
        indskr_activitycontactid: c.activityContactId,
        indskr_contactid: c.contactId,
        indskr_name: src?.fullName?.trim() || '',
        indskr_joineddate: '',
        indskr_leftdate: '',
        indskr_sequence: null,
      };
    });
  }
  private _finalizeCreatePayloadSubject(reqBody: any, rawNewMeeting: any, payload: InitiateMeetingPayload): void {
    if (!this.secondaryInfoService.isAppointmentSecInfoConfigured || payload.isSubjectFinalForCreate) {
      return;
    }

    const meetingForSubject = new AppointmentActivity(rawNewMeeting);
    if (payload.contactForCreateSubject) {
      meetingForSubject.contacts = [payload.contactForCreateSubject];
    }
    const subject = this.setMeetingSubject(meetingForSubject);
    if (subject) {
      reqBody['subject'] = rawNewMeeting['subject'] = subject;
    }
  }

  private _getCreateRequestFields(reqBody: any) {
    return {
      subject: reqBody['subject'],
      location: reqBody['location'],
      scheduledStart: reqBody['scheduledstart'],
      scheduledEnd: reqBody['scheduledend'],
    };
  }

  private _setCreateRequestFields(activity: AppointmentActivity, reqBody: any): void {
    activity['createRequestFields'] = this._getCreateRequestFields(reqBody);
  }

  private async _createPendingMeeting(rawNewMeeting: any): Promise<AppointmentActivity | undefined> {
    rawNewMeeting['indskr_isofflinemeeting'] = true;
    const pendingMeeting = new (rawNewMeeting.location === 'LiveMeet' ? LiveMeetActivity : AppointmentActivity)(rawNewMeeting);
    pendingMeeting['isCreatePendingSync'] = true;
    pendingMeeting['createRequestFields'] = rawNewMeeting['createRequestFields'];
    const success = await this.activityService.upsertMeetingsOfflineData(pendingMeeting, false, true);
    return success ? pendingMeeting : undefined;
  }
  private createTeamsMeeting(reqBody, activityId) {
    const teamsConfig = this.authenticationService.userConfig.teamsConfig;
    const crmInstance = this.authenticationService.userConfig.activeInstance;
    const teamsMeetingPayload = {
      startDateTime: reqBody.scheduledstart,
      endDateTime: reqBody.scheduledend,
      subject: reqBody.subject,
      contentUrl: teamsConfig.contentUrl,
      teamsAppID: teamsConfig.teamsCustomAppId,
      meetingId: activityId,
      dynamicsInstance: crmInstance.url,
      entryPointUrl: crmInstance.entryPointUrl
    }
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.set('X-MS-Graph-Token', 'true');
    const url: string = crmInstance.entryPointUrl + Endpoints.activites.TEAM_MEETING_ACTIVITY;
    this.http.post(url, teamsMeetingPayload, { headers: headers }).toPromise().then(async (data: any) => {
      console.log(data)
      if (this.activityService.selectedActivity?.ID == activityId) {
        let activity: AppointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
        activity.indskr_teamslink = data.joinUrl;
        activity.indskr_teams_meeting_id = data.id;
        await this.dynamics.update(activityId, "appointments", { indskr_teamslink: data.joinUrl, indskr_teams_meeting_id: data.id });
        await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity, true);
        this.events.publish("detectChangesOnActivityDetails");
      }
    });
  }

  private async _createNewMeetingReq(reqBody: any): Promise<MeetingCreateResponseDTO> {
    if (this.deviceService.isOffline) {
      return;
    }
    const url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.INITIATE_MEETING_V2;
    const headers = Endpoints.meeting.INITIATE_MEETING_HEADERS;
    headers.headers = headers.headers.set(
      'X-BusinessUnitId',
      this.authenticationService.user.xBusinessUnitId
    ).set(
      "X-PositionId",
      this.authenticationService.user.xPositionID
    );
    const { timeZone } = Intl?.DateTimeFormat()?.resolvedOptions();
    if (timeZone) {
      headers.headers = headers.headers.set(
        'X-Zone-Id',
        timeZone,
      );
    }
    const pastActivityGracePeriod: string = !this.deviceService.isOffline ? (this.authenticationService.user.maxMeetingStartDays).toString() : '';
    let headerAndPrarms = {
      ...headers
    }
    return await this.http.post<MeetingCreateResponseDTO>(url, reqBody, headerAndPrarms).toPromise();
  }

  public async uploadPhotosToBlobStorgae(payload: Photo[]) {
    const activity = this.activityService.selectedActivity as AppointmentActivity;
    const createdAt = new Date().getTime();
    payload = payload.map((image) => {
      const base64String = image.base64String.replace(/^data:image\/\w+;base64,/, '');
      return { ...image, base64String, createdAt: createdAt };
    });
    try {
      const headers = Endpoints.authentication.AUTHENTICATE_USER_STATUS;
      const url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.photos.UPLOAD_PHOTOS;
      const photosUploaded: UploadedPhoto[] = await this.http.post<UploadedPhoto[]>(url, payload, headers).toPromise();
      await this.updateInStorePhotos(photosUploaded.map(photo => { return { indskr_photoattachmentid: photo.photoId, photoAttachmentId: photo.photoId, indskr_photourl: photo.photoUrl, ...photo } }));
    } catch (error) {
      console.error("Failed to upload photos: ", error);
    }
  }

  public async updateInStorePhotos(payload: any[]) {
    try {
      const activity = this.activityService.selectedActivity as AppointmentActivity;
      const headers = Endpoints.authentication.AUTHENTICATE_USER_STATUS;
      const url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.UPDATE_INSTORE_PHOTOS.replace("{activityId}", activity.ID);
      await this.http.put<any>(url, payload, headers).toPromise();
      if (isEmpty(activity.inStorePhotos)) {
        activity.inStorePhotos = payload.filter(req => !req['deleted']);
      } else {
        const deletedIds = payload.filter(req => req['deleted']).map(req => req['photoAttachmentId']);
        activity.inStorePhotos = activity.inStorePhotos.filter(photo => !deletedIds.includes(photo.indskr_photoattachmentid));
        activity.inStorePhotos.push(...payload.filter(req => !req['deleted']).map(photo => { return { createdOn: photo['createdAt'], ...photo } }));
      }
      await this.activityService.upsertMeetingsOfflineData(activity);
    } catch (error) {
      console.error("Failed to upload updateInStorePhotos: ", error);
    }
  }

  private async _handleMeetingCreationResponse(res: MeetingCreateResponseDTO, activity: AppointmentActivity, noAsyncFlow = false) {
    // Updates object and offline doc, and creates a meeting doc.
    if (res.activityId && res.offlineMeetingId === activity.offlineMeetingId) {
      activity.meetingURL = res.indskr_meetingurl;
      const previousActivityId = activity.ID;
      activity.ID = res.activityId;
      // OMNI-62429: re-point child AOs so the single-AO cap keeps counting them
      this.activityService.remapInMeetingSampleActivities(res.offlineMeetingId, res.activityId);
      activity.lastUpdatedTime = new Date().getTime();
      activity.isOfflineMeeting = false;
      delete activity['isCreatePendingSync'];
      this.activityService.contactCenterContactInputs$.subscribe((value) => {
        if (value) {
          activity.contacts.push(value);
          this.activityService.selectedActivity = activity;
          this.addContactsToMeeting(activity);
          this.events.publish("detectChangesOnActivityDetails"); // refresh meeting structure
          if (!this.uiService.toolsActivityActive) {
            this.events.publish('refreshAgenda');
          } else this.uiService.agendaRefreshRequired = true;
        }
      }).unsubscribe();
      this.activityService.contactCenterContactInputs$.next(null);

      const _id = activity._id = DB_KEY_PREFIXES.MEETING_ACTIVITY + res.activityId;

      // Records captured in the same breath as the meeting hold whatever id it had then. Point
      // them at the real one now it exists, so they can reach Dynamics and still belong to this
      // meeting. Its own failure must not take down the creation response.
      this.nextCallObjectiveDataService.remapObjectivesToMeeting(previousActivityId, res.activityId)
        .catch(error => console.error('_handleMeetingCreationResponse: re-pointing objectives failed', error));

      if (!noAsyncFlow) {
        // Subscribe to ws
        this.events.publish('ws:subscribeToMeetingTopic', activity);
      }

      // Handle offline doc
      try {
        await this.disk.updateOrInsert('offlineMeetings', (offlineMeetingsDoc: { meetings: any[] }) => {
          if (!offlineMeetingsDoc || !Array.isArray(offlineMeetingsDoc.meetings)) {
            console.warn('_handleMeetingCreationResponse: offline meeting document is empty..');
            offlineMeetingsDoc = { meetings: [] };
          } else {
            const idx = offlineMeetingsDoc.meetings.findIndex(m => m.offlineMeetingId === res.offlineMeetingId);
            if (idx >= 0) {
              const rawOfflineMeeting = offlineMeetingsDoc.meetings[idx];
              if (rawOfflineMeeting.hasOfflineChange) {
                // Something changed while waiting for the meeting creation response. Update offline doc and treat as offline doc
                rawOfflineMeeting['indskr_meetingurl'] = activity.meetingURL;
                rawOfflineMeeting['activityid'] = activity.ID;
                rawOfflineMeeting['lastUpdatedTime'] = activity.lastUpdatedTime;
                rawOfflineMeeting['indskr_isofflinemeeting'] = false;
              } else {
                // Nothing changed while waiting for the meeting creation response. Remove from offline doc
                this.activityService.deleteFromOfflineMeetingIds(activity.offlineMeetingId);
                offlineMeetingsDoc.meetings.splice(idx, 1);
              }
            } else {
              console.warn(`_handleMeetingCreationResponse: couldn't find ${res.offlineMeetingId} from offline document`);
            }
          }

          // Track offline data count
          this.disk.setOfflineDataCount(OFFLINE_DATA_COUNT_ENTITY_NAME.MEETING, offlineMeetingsDoc.meetings.length);
          return offlineMeetingsDoc;
        });
      } catch (error) {
        console.error('_handleMeetingCreationResponse: ', error);
      }

      // Create a meeting record
      try {
        await this.disk.createDocument(_id, activity.DTO);
      } catch (error) {
        console.error('_handleMeetingCreationResponse: createDocument: ', error);
      }

      // Stream to other pages
      this.uiService.setUIServiceData({
        view: "new-activity", data: {}
      });
    } else {
      console.warn(`_handleMeetingCreationResponse: offline meeting ID ${activity.offlineMeetingId} does not match with ${res.offlineMeetingId}`);
    }
  }


  /**
   * Called in the background when the server responds to a meeting-create request that already
   * timed out (> 3 s) and was materialised as a local pending meeting.
   *
   * Responsibilities:
   *  1. Optionally associates the event link.
   *  2. Calls _handleMeetingCreationResponse to merge real server IDs into the offline doc and
   *     the in-memory activity object (with noAsyncFlow=true so we skip the WS subscription
   *     step — the UI is already live and using the pending meeting).
   *  3. Applies any upfront contacts embedded in the original create request.
   *  4. If the user edited the meeting while we were waiting (hasOfflineChange === true),
   *     triggers _backgroundSyncOfflineMeeting to push those changes to the server silently.
   */
  private async _handleDelayedMeetingCreationResponse(
    res: MeetingCreateResponseDTO,
    activity: AppointmentActivity,
    payload: InitiateMeetingPayload,
    reqBody: any,
  ): Promise<void> {
    // 1. Optional event association — errors are swallowed; the meeting is already live.
    if (payload.eventId) {
      await this.msEventService.associateEvent(payload.eventId, res.activityId)
        .then(() => res).catch(() => res);
    }

    // 2. Merge server IDs into the offline doc and activity object.
    //    noAsyncFlow = true: the meeting is already showing in the UI, skip WS subscribe here.
    await this._handleMeetingCreationResponse(res, activity, /* noAsyncFlow */ true);

    // 3. Contacts that were embedded in the original create request.
    if (payload.contacts?.length && res.createdContacts?.length) {
      this._applyUpfrontContacts(activity, payload.contacts, res.createdContacts);
    }

    // 4. Race-condition edits: the user saved changes while waiting for the creation response.
    //    _handleMeetingCreationResponse sets hasOfflineChange and keeps the meeting in the
    //    offline doc with the real activityId.  We now upload those pending changes silently.
    if (activity.hasOfflineChange) {
      this._backgroundSyncOfflineMeeting(activity).catch(err =>
        console.error('[createNewMeeting] _backgroundSyncOfflineMeeting error:', err)
      );
    }
  }

  /**
   * Silently uploads a single offline-pending meeting to the server after its creation
   * response has been merged.  Used exclusively as a background follow-up when a user edited
   * a meeting while the initial create request was still in-flight (i.e. hasOfflineChange).
   *
   * No loader is shown and no notification is raised.  On success the meeting is removed from
   * the offline doc, just as the regular full offline-upload would do.
   */
  private async _backgroundSyncOfflineMeeting(activity: AppointmentActivity): Promise<void> {
    if (this.deviceService.isOffline) return;

    const offlineMeetingsDoc = await this.disk.loadOfflineMeetings();
    if (!offlineMeetingsDoc?.meetings?.length) return;

    const meetingPayload = offlineMeetingsDoc.meetings.find(
      m => m.offlineMeetingId === activity.offlineMeetingId,
    );
    if (!meetingPayload) {
      console.warn('[_backgroundSyncOfflineMeeting] meeting not found in offline doc for', activity.offlineMeetingId);
      return;
    }

    // Mirror the payload normalization used by ActivityDataService#getOfflineMeetingsToForceUpload.
    // Without this, delayed-create fallback can upload raw meeting objects that still contain
    // transitional fields (e.g. activityid / hasOfflineChange), which backend may reject.
    const sanitizedMeetingPayload = JSON.parse(JSON.stringify(meetingPayload));
    this.activityDataService.offlineMeetingPayloadSanityCheck(sanitizedMeetingPayload);

    const url = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.offline.UPLOAD_MEETING;
    // Re-use the same header strategy as the full offline-upload in ActivityDataService.
    const headers = Endpoints.presentations.FAVOURITE_PRESENTATION_HEADER;
    headers.headers = headers.headers.set('X-SystemUserId', this.authenticationService.user.systemUserID);
    const { timeZone } = Intl?.DateTimeFormat()?.resolvedOptions();
    if (timeZone) {
      headers.headers = headers.headers.set('X-Zone-Id', timeZone);
    }

    // Build a minimal upload body that mirrors the full payload shape but contains only the
    // one meeting that needs syncing.  All other arrays are empty so the endpoint ignores them.
    const body = {
      offlineMeetings: [sanitizedMeetingPayload],
      offlinePhonecalls: [],
      offlineTimeOffs: [],
      offlineSampleDrops: [],
      offlineEmails: [],
      offlineFollowUpTasks: [],
      offlineProgressReports: [],
      offlineConsents: [],
      offlineMedicalEnquiry: [],
      offlineSurgeryOrder: [],
    };

    try {
      const response: any = await this.http.post(url, body, headers).toPromise();
      if (response?.offlineMeetings) {
        let syncedSuccessfully = false;
        // Mirror the cleanup logic in ActivityDataService.uploadOfflineMeetingsTimeOffs…:
        // on a successful server acknowledgement remove the entry from the offline doc.
        await this.disk.updateOrInsert('offlineMeetings', (doc: { meetings: any[] }) => {
          if (!doc?.meetings) return doc;
          for (const key in response.offlineMeetings) {
            if (response.offlineMeetings.hasOwnProperty(key)) {
              const meetingResponse = response.offlineMeetings[key];
              if (!meetingResponse.errorId) {
                const idx = doc.meetings.findIndex(m => m.offlineMeetingId === meetingResponse.offlineMeetingId);
                if (idx >= 0) {
                  doc.meetings.splice(idx, 1);
                  syncedSuccessfully = true;
                  // Clear from the in-memory hashmap so the badge count is accurate.
                  this.activityService.deleteFromOfflineMeetingIds(meetingResponse.offlineMeetingId || activity.offlineMeetingId);
                }
              }
            }
          }
          this.disk.setOfflineDataCount(OFFLINE_DATA_COUNT_ENTITY_NAME.MEETING, doc.meetings.length);
          return doc;
        });
        // OMNI-61539: a signature can be captured before this background sync runs — once the
        // meeting is on the server, drop the local base64 image and terms from the activity and
        // its raw doc so an offline user is told to reconnect to view it.
        if (syncedSuccessfully) {
          await this.activityDataService.clearUploadedOfflineSignature(null, activity.ID);
        }
        console.info('[_backgroundSyncOfflineMeeting] synced meeting', activity.offlineMeetingId, '→', activity.ID);
      }
    } catch (err) {
      // Leave the meeting in the offline queue — it will be picked up by the next full sync.
      console.error('[_backgroundSyncOfflineMeeting] upload failed for', activity.offlineMeetingId, err);
    }
  }

  public addGuestToMeetingContacts(guest, isInboundFlow = false) {
    console.log(guest);
    let isContact = this.contactService.getContactByID(guest['indskr_contactid']);
    if (!isContact) {
      let guestName = guest.indskr_name.split(' ');
      let lastName = guestName.splice(1)
      let rawObj = {
        'contactid': guest['indskr_contactid'],
        'firstname': guestName[0],
        'lastname' : lastName,
        'indskr_joinstatus': guest['indskr_joinstatus'],
        'indskr_isguest': guest['indskr_isguest'],
        'indskr_joineddate': guest['indskr_joineddate'],
        'indskr_leftdate': guest['indskr_leftdate'],
        'indskr_isremote': guest['indskr_isremote'] || true,
        'indskr_leftmanually': guest['indskr_leftmanually'] || false,
        'indskr_sequence': guest['indskr_sequence'] || 0,
        'statuscode': guest['statuscode'] || 1
      }

      let contact = new Contact(rawObj);
      if (!isInboundFlow) {
        // Only add for remote meeting.
        // This is not to break existing remote meeting feature. Clean up needs to be done.
        this.contactService.contacts.push(contact);
        this.contactService.upsertRawContactToLocalDB(rawObj, false, true);
      }
      (this.activityService.selectedActivity['contacts']) ? this.activityService.selectedActivity['contacts'].push(contact) : undefined;
      this.events.publish("refreshSeletecContacts");
    }
  }


  public async uploadInteractiveHTMLEvent() {
    //If offline, ignore
    if (this.deviceService.isOffline) return;

    let offlineEvents = await this.disk.retrieve('ihtml_events', true);

    if (offlineEvents && offlineEvents.events) {

      offlineEvents.events.map(async event => {
        let firstEvent = event;

        let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
          Endpoints.ihtml.UPLOAD_TRACKING;

        //Replace important variables in url
        url = url.replace('{activityId}', firstEvent.IDs.activity);
        url = url.replace('{slideId}', firstEvent.IDs.slide);
        url = url.replace('{presentationId}', firstEvent.IDs.presentation);


        let response = await this.http.post(url, offlineEvents.events).toPromise();
        console.log(response);
      });



      this.disk.remove('ihtml_events');
    }
  }

  public async addRemoveAccompaniedUsers(raw: AccompainedUser[]) {
    // selectedActivity still holds the pre-change list at this point - setAccompaniedUser runs only
    // after the patch below - so this is the one place the removals are still derivable. Without
    // them the payload says who remains but never who left, and the server keeps the old covisitor.
    // v2 deletes by indskr_accompanieduser junction id, NOT by user id: sending the user id makes
    // the server issue DELETE indskr_accompaniedusers(<systemuserid>), which 404s.
    const previousUsers: AccompainedUser[] = this.activityService.selectedActivity?.['accompaniedUserList'] ?? [];
    const retainedIds = new Set((raw ?? []).map(u => u?.id).filter(Boolean));
    const removedUsers = previousUsers.filter(u => u?.id && !retainedIds.has(u.id));
    const removedIds: string[] = removedUsers.map(u => u.accompaniedUserId).filter(Boolean);
    if (removedIds.length !== removedUsers.length) {
      console.warn('addRemoveAccompaniedUsers: no junction id for', removedUsers.filter(u => !u.accompaniedUserId).map(u => u.id));
    }
    //online case
    if (!this.deviceService.isOffline) {
      //online activity registered on Dynamics
      if (!this.activityService.selectedActivity.ID.includes('offline_')) {
        try {
          const res = await this.activityDataService.addAccompaniedUser(raw, this.activityService.selectedActivity.ID, removedIds).toPromise();
          // v2 returns the junction id Dynamics assigned to each newly added user. Stamp it on
          // before setAccompaniedUser clones the list, or removing that user later has no id to
          // delete by until the next sync brings one down.
          const createdUsers: Array<{ userId: string, accompaniedUserId: string }> = res?.['createdUsers'] ?? [];
          createdUsers.forEach(created => {
            const match = raw?.find(u => u?.id === created?.userId);
            if (match && created?.accompaniedUserId) match.accompaniedUserId = created.accompaniedUserId;
          });
          await this.activityService.setAccompaniedUser(raw);
          await this.storeOfflineJointMeeting(raw);
          this.activityService.notifyCalendarInviteUpdate(this.activityService.selectedActivity as AppointmentActivity);
        } catch (error) {
          //someerror occured
          //proceed for offline saving data
          console.error("addRemoveAccompaniedUsers: ", error);
          await this.storeOfflineJointMeeting(raw);
          //To clear the selection data for next cycle
        }
      }
      //offline id detected, data to be stored for delta sync in disk service
      else {
        await this.storeOfflineJointMeeting(raw);
      }
    }
    //device set to offline
    else {
      // logic for offline saving the data
      this.activityDataService.activityDetailsLoaded = true;
      await this.storeOfflineJointMeeting(raw);
      //To clear the selection data for next cycle
    }
  }

  public async updateUserNotes() {

  }

  //common logic for storing offline joint meeting data to disk service for delta sync
  private async storeOfflineJointMeeting(raw: AccompainedUser[]) {
    let activity: any = this.activityService.selectedActivity;
    await this.activityService.setAccompaniedUser(raw);
    console.log("offline joint meeting detected, initiating storage for data");
    try {
      await this.activityService.upsertMeetingsOfflineData(activity);
    } catch (error) {
    }
  }

  public async createMeetingFromPresentation(pres: Presentation[]) {

    //Going to need a payload for initiation
    let startTime, endTime;
    startTime = new Date();
    endTime = new Date();
    let meetingDuration = this.authenticationService.user.meeting_duration || 30;
    endTime = this.dateTimeFormatsService.addMinutesToDate(startTime, meetingDuration);

    let payload: InitiateMeetingPayload = new InitiateMeetingPayload(
      "Meeting",
      "",
      startTime.getTime(),
      endTime.getTime(),
      "",
      this.activityService.generateOfflineMeetingId()
    );

    try {
      if (this.authenticationService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT)) {
        payload["subject"] = `${this.translate.instant("VISIT")}`;
      } else {
        payload["subject"] = this.translate.instant('MEETING') + ' - ' + this.authenticationService.user.displayName;
      }
      let newMeeting = await this.createNewMeeting(payload);

      if (newMeeting) {
        let data;
        if (!newMeeting.createdOffline) {
          // Online created meeting
          data = { id: newMeeting.ID, ...payload }
        } else {
          // Offline created meeting
          data = {
            id: newMeeting.ID,
            subject: newMeeting.subject,
            location: newMeeting.location,
            scheduledStart: newMeeting.scheduledStart,
            scheduledEnd: newMeeting.scheduledEnd,
          };
        }

        this.uiService.setUIServiceData({
          view: "new-activity", data,
        }); // this is an observable stream

        this.activityService.selectedActivityAtHome = this.activityService.selectedActivity = newMeeting;
        this.uiService.showRightPane = true;
        this.events.publish('initActivityKeyMessages');
        if (pres) {

          if (this.activityService.selectedActivity instanceof AppointmentActivity) {
            if (!this.activityService.selectedActivity['presentations']) this.activityService.selectedActivity['presentations'] = [];
            pres.forEach(p => {
              p.isAutoLoaded = false;
              this.activityService.selectedActivity['presentations'].push(p);
            });

            if (!this.deviceService.isOffline && !this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
              try {
                await this.addContentToMeeting(this.activityService.selectedActivity.presentations, this.activityService.selectedActivity)
              } catch (error) {
                this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity, false, true)
                  .catch(err => this.notificationService.notify(this.translate.instant("ERROR_UPDATING_MEETING_PRESENTATIONS"), 'Meeting Data Service'));
              }
            } else {
              this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity);
            }
          }
        }
      }
      Promise.resolve();
    } catch (error) {
      Promise.reject(error);
    }

  }

  async sendMeetingInvite(activity: AppointmentActivity) {
    if (!activity) {
      console.error('sendMeetingInvite: Invalid activity provided', activity);
      throw new GeneralException(ErrorCode.E00, 'Invalid activity.');
    }
    if (activity && activity.isInviteSent === DynamicsBoolean.true) {
      console.error('sendMeetingInvite: Invite has been sent already', activity);
      throw new GeneralException(ErrorCode.E00, 'Invite has been sent already.');
    }
    if (this.deviceService.isOffline) {
      console.error('sendMeetingInvite: Device offline', activity);
      throw new GeneralException(ErrorCode.E01, 'Device is offline. Please try again later.');
    }
    if (this.activityService.hasOfflineMeetingData(activity.ID)) {
      console.error('sendMeetingInvite: There is local offline data', activity);
      throw new GeneralException(ErrorCode.E01, 'Meeting has un-synced local data. Please sync and try again later.');
    }

    // Online
    const url: string = (this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.SEND_MEETING_INVITE).replace('{activity_id}', activity.ID);
    let headers = new HttpHeaders();
    headers = headers.set('X-SystemUserId', this.authenticationService.user.xSystemUserID);

    // Server upload
    try {
      const response = await this.http.patch(url, {}, { headers }).pipe(timeout(30000)).toPromise();
    } catch (error) {
      console.error('sendMeetingInvite: server upload: ', error);
      if (error instanceof HttpErrorResponse && error.error.errorCode === 'ERR_IO_ME11') {
        // Invite has been sent already
        throw new GeneralException(ErrorCode.E03, 'Invite has been sent already. Please run a manual sync and update agenda.');
      } else {
        throw new GeneralException(ErrorCode.E01, 'Failed to send invite. Please try again later.');
      }
    }

    // Local update
    try {
      activity.isInviteSent = DynamicsBoolean.true;
      await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity, true);
    } catch (error) {
      console.error('sendMeetingInvite: local update: ', error);
      throw new GeneralException(ErrorCode.E03, 'Invite has been sent but failed to update local data. Please run a manual sync.');
    }
  }

  async updateMeetingDescription(activity: AppointmentActivity, description: string) {
    if (!activity || description === undefined || description === null) {
      console.error('updateMeetingDescription: Invalid param(s) provided', activity, description);
      throw new GeneralException(ErrorCode.E00, 'Invalid input.');
    }

    if (this.deviceService.isOffline || this.activityService.hasOfflineMeetingData(activity.ID)) {
      // Offline
      try {
        activity.description = description;
        await this.activityService.upsertMeetingsOfflineData(activity);
      } catch (error) {
        console.error('updateMeetingDescription: ', error);
        throw new GeneralException(ErrorCode.E01, 'Failed to update description. Please try again later.');
      }
    } else {
      const url: string = (this.authenticationService.userConfig.activeInstance.entryPointUrl
        + Endpoints.meeting.PATCH_MEETING_V2).replace('{activity_id}', activity.ID);
      let headers = new HttpHeaders();
      headers = headers.set('X-SystemUserId', this.authenticationService.user.xSystemUserID);

      // Server upload
      try {
        const response = await this.http.patch(url, { description }, { headers })
          .pipe(timeout(30000)).toPromise();
      } catch (error) {
        console.error('updateMeetingDescription: server upload: ', error);
        throw new GeneralException(
          ErrorCode.E01,
          'Failed to update description. Please try again later.'
        );
      }

      // Local update
      try {
        activity.description = description;
        await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity, true);
      } catch (error) {
        console.error('updateMeetingDescription: local update: ', error);
        throw new GeneralException(
          ErrorCode.E03,
          'Description has been updated but failed to update local data. Please run a manual sync.'
        );
      }
    }
  }

  async updateCovisitorComplianceAck(activity: AppointmentActivity, acked: boolean, description: string) {
    if (!activity || acked === undefined || acked === null) {
      console.error(
        'updateCovisitorComplianceAck: Invalid param(s) provided',
        activity,
        acked,
        description
      );
      throw new GeneralException(ErrorCode.E00, 'Invalid input');
    }

    const prevAcked: boolean = activity.covisitorComplianceAcked;
    const prevDescription: string = activity.covisitorComplianceDescription;

    activity.covisitorComplianceAcked = acked;
    activity.covisitorComplianceDescription = acked === true ? description : '';

    if (this.deviceService.isOffline || this.activityService.hasOfflineMeetingData(activity.ID)) {
      // Offline
      try {
        await this.activityService.upsertMeetingsOfflineData(activity);
      } catch (error) {
        console.error('updateCovisitorComplianceAck: ', error);
        activity.covisitorComplianceAcked = prevAcked;
        activity.covisitorComplianceDescription = prevDescription;

        const errorMsg: string = this.translate.instant('MEETING_COVISITOR_COMPLIANCE_UPDATE_FAIL_1')
          + ' ' + this.translate.instant('PLEASE_TRY_AGAIN_LATER');
        throw new GeneralException(
          ErrorCode.E01,
          errorMsg,
        );
      }
    } else {
      // Online
      const url: string = (this.authenticationService.userConfig.activeInstance.entryPointUrl
        + Endpoints.meeting.PATCH_MEETING_V2).replace('{activity_id}', activity.ID);
      let headers = new HttpHeaders();
      headers = headers.set('X-SystemUserId', this.authenticationService.user.xSystemUserID)

      // Server
      try {
        const response = await this.http.patch(
          url,
          {
            indskr_covisitorComplianceAcked: activity.covisitorComplianceAcked,
            indskr_covisitorComplianceDescription: activity.covisitorComplianceDescription,
          },
          { headers }
        )
          .pipe(timeout(30000))
          .toPromise();
      } catch (error) {
        console.error('updateCovisitorComplianceAck: server update: ', error);
        activity.covisitorComplianceAcked = prevAcked;
        activity.covisitorComplianceDescription = prevDescription;

        const errorMsg: string = this.translate.instant('MEETING_COVISITOR_COMPLIANCE_UPDATE_FAIL_1')
          + ' ' + this.translate.instant('PLEASE_TRY_AGAIN_LATER');
        throw new GeneralException(
          ErrorCode.E01,
          errorMsg,
        );
      }

      // Local
      try {
        await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity, true);
      } catch (error) {
        console.error('updateCovisitorComplianceAck: local update: ', error);
        const errorMsg: string = this.translate.instant('MEETING_COVISITOR_COMPLIANCE_UPDATE_FAIL_2')
          + ' ' + this.translate.instant('PLEASE_RUN_MANUAL_SYNC');
        throw new GeneralException(
          ErrorCode.E03,
          errorMsg,
        );
      }
    }
  }

  //Add or update meeting notes attachment
  async updateMeetingAttachments(payload) {
    let activity: AppointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
    if (activity.associatedAttachments.length) {
      await this.dynamics.update(activity.associatedAttachments[0].annotationId, 'annotations', payload).then(async (res) => {
        if (res) {
          activity.associatedAttachments[0].attachmentName = res['filename'];
          console.log(res);
        }
      }).catch((e) => {
        console.log("Error updating meeting attachment", e);
      })
    } else {
      payload['annotationid'] = Guid.create().toString();
      await this.dynamics.create(payload, 'annotations').then(async (res) => {
        if (res) {
          let attachment = {
            annotationId: res['annotationid'],
            attachmentName: res['filename']
          };
          activity.associatedAttachments.push(attachment);
        }
      }).catch((e) => {
        console.log("Error adding meeting attachment", e);
      })
    }
    await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity as AppointmentActivity, true);
  }

  async removeMeetingAttachment() {
    let activity: AppointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
    if (activity.associatedAttachments.length) {
      await this.dynamics.delete(activity.associatedAttachments[0].annotationId, 'annotations').then(async (res) => {
        activity.associatedAttachments = [];
        console.log(res);
      }).catch((e) => {
        console.log("Error deleting meeting attachment", e);
      })
      await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity as AppointmentActivity, true);
    }
  }

  public async uploadMeetingNotesOnline() {
      let offlineNotes = await this.disk.retrieve(DB_KEY_PREFIXES.OFFLINE_MEETING_NOTES);
      if(offlineNotes && offlineNotes.raw && Array.isArray(offlineNotes.raw) && offlineNotes.raw.length != 0){
        const pendingRaw = offlineNotes.raw.filter(item => item.pendingPushForDynamics);
        const payload = pendingRaw.map(item=>{
        if(item.annotationid.includes('offlinmeetingnote')) {
          return {
            activityid: item.activityid,
            createdon: item.createdon,
            notetext: item.notetext,
            ownerid: item.ownerid,
            filename: item.filename,
            filesize: item.filesize,
            documentbody: item.documentbody,
            mimetype: item.mimetype,
            deleted: item.deleted,
            isOffLabel: item.isOffLabel ?? false,
            subject: item.isOffLabel ? 'OFFLABEL' : null
          };
        } else {
          if(item.deleted){
            return {
              deleted: true,
              annotationid: item.annotationid
            };
          } else if(item.fileupdated){
            return {
              notetext: item.notetext,
              annotationid: item.annotationid,
              filename: item.filename,
              filesize: item.filesize,
              documentbody: item.documentbody,
              mimetype: item.mimetype,
              isOffLabel: item.isOffLabel ?? false,
              subject: item.isOffLabel ? 'OFFLABEL' : null
            };
          } else if(item.fileremoved){
            return {
              notetext: item.notetext,
              annotationid: item.annotationid,
              filename: item.filename,
              filesize: item.filesize,
              documentbody: item.documentbody,
              mimetype: item.mimetype,
              isOffLabel: item.isOffLabel ?? false,
              subject: item.isOffLabel ? 'OFFLABEL' : null
            };
          } else {
            return {
              notetext: item.notetext,
              annotationid: item.annotationid,
              isOffLabel: item.isOffLabel ?? false,
              subject: item.isOffLabel ? 'OFFLABEL' : null
            };
          }
        }
      });
      let url = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.UPLOAD_MEETING_NOTES;
      // The share is a client-specific Dynamics action; MSE calls it only when asked
      if (this.authenticationService.hasOffLabelNotesAccess()) {
        url += '?shareNonOffLabelNotes=true';
      }
      const response = await this.http.post(url, payload, Endpoints.headers.content_type.json).toPromise();
      if(response && Array.isArray(response) && response.length != 0){
        for(let idx=0;idx<response.length;idx++) {
          let res = response[idx];
          if(res.hasOwnProperty('annotationid')){
            // Add to real offline db for meeting notes
            try {
                  let activity: AppointmentActivity = this.activityService.getActivityByID(pendingRaw[idx]['activityid']) as AppointmentActivity;
                  if(activity && activity.meetingNotes && activity.meetingNotes.length>0) {
                    let noteIdx = activity.meetingNotes.findIndex(item => item['noteId'] == pendingRaw[idx]['annotationid'])
                    if(noteIdx >=0) {
                      if(payload[idx].deleted == true){
                        activity.meetingNotes.splice(noteIdx,1);
                      } else {
                        activity.meetingNotes[noteIdx]['noteId'] = res['annotationid'];
                        activity.meetingNotes[noteIdx]['noteText'] = pendingRaw[idx]['notetext'];
                        activity.meetingNotes[noteIdx]['documentName'] = pendingRaw[idx]['filename'];
                        activity.meetingNotes[noteIdx]['documentMimeType'] = pendingRaw[idx]['mimetype'];
                        activity.meetingNotes[noteIdx]['pendingPushForDynamics'] = false;
                        if(activity.meetingNotes[noteIdx]['activityId'].includes('offline_meeting_')) {
                          activity.meetingNotes[noteIdx]['activityId'] = pendingRaw[idx]['activityid'];
                        }
                      }
                    }
                  }
                  if(activity) await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity as AppointmentActivity, true);
                  pendingRaw[idx].pendingPushForDynamics = false;
            } catch (error) {
                console.log(error);
            }
          }
        }
        offlineNotes.raw = offlineNotes.raw.filter(item => item.pendingPushForDynamics);
        offlineNotes.count = offlineNotes.raw.length;
        this.disk.setOfflineDataCount(OFFLINE_DATA_COUNT_ENTITY_NAME.MEETING_NOTES, offlineNotes.count);
        await this.disk.updateOrInsert(DB_KEY_PREFIXES.OFFLINE_MEETING_NOTES, doc => {
            doc = offlineNotes;
            return doc;
        }).catch(error => console.error('Save Offline Meeting Notes to DB error: ', error));
      }
      return response;
    } else {
      return null;
    }
}
  public async fetchMeetingObjectives(loadFromDBOnly: boolean) {
    if(!this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_OBJECTIVE_SELECTION)) return;
    if (loadFromDBOnly) {
      await this.disk.retrieve(DB_KEY_PREFIXES.MEETING_OBJECTIVES).then((data) => {
        if (data && data['raw']) {
            this.meetingObjectives = data['raw'];
            console.log(`Meeting objectives from disk : ${data['raw'].length}`);
        }
    }).catch((err) => console.error("loadEventsFromDB: Error saving events data to offline db!", err));
    } else {
      return await this.dynamics.executeFetchQuery('indskr_meetingobjectiveses', fetchQueries.meetingObjectives).then(async (response) => {
        this.meetingObjectives = response;
        await this.disk.updateOrInsert(DB_KEY_PREFIXES.MEETING_OBJECTIVES, doc => ({ raw: response })).catch((err) => console.error("syncEvents: Error saving meeting objectives data to offline db!", err));
      })
    }
  }

  public async saveMeetingObjectives(payload) {
    if (!this.deviceService.isOffline && !this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
      const url: string = (this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.SAVE_MEETING_OBJECTIVES).replace('{activity_id}', this.activityService.selectedActivity.ID);
      await this.http
        .put(url, payload)
        .toPromise().catch((err) => console.error(err));
    }
    await this.activityService.upsertMeetingsOfflineData(this.activityService.selectedActivity as AppointmentActivity, false, false)
  }

  public async updateMeetingCheckInCheckout(activity, payload, data?: Photo[],  gpsActivitiyPayload?) {
    try {
      const createdAt = new Date().getTime();
      if(!isEmpty(data)) {
        data = data.map((image) => {
          const base64String = image.base64String.replace(/^data:image\/\w+;base64,/, '');
          return { ...image, base64String, createdAt: createdAt };
        });

        payload['gpsActivityPhotos'] = data;
      }
      let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.GPS_CHECK_IN;
      url = url.replace("{activity_id}", activity.ID);
      const response: any = await this.http.put(url, payload).toPromise();
      const photosUploaded = response['gpsActivityPhotos'];
      if (response && !isEmpty(photosUploaded) && !isEmpty(gpsActivitiyPayload) ) {
        photosUploaded.forEach((photoUploaded)=>{
          gpsActivitiyPayload[0]['photoAttachmentIds'].push(photoUploaded.photoId);
        })
        gpsActivitiyPayload[0]['indskr_gpscheckindetailsid'] = response['indskr_gpscheckindetailsid'];
        await this.appealDataService.updateGPSActivityPhotos(activity.ID, gpsActivitiyPayload);
        const photos: PhotoResponse[] = photosUploaded.map(p => {
          return { indskr_photoattachmentid: p.photoId, indskr_photoorigin: p.photoOrigin, indskr_photourl: p.photoUrl, name: p.name }
        });
        const gpsActivityPhoto: GPSActivityPhoto = {
          indskr_gpscheckindetailsid: gpsActivitiyPayload[0]['indskr_gpscheckindetailsid'],
          indskr_type: gpsActivitiyPayload[0]['indskr_type'],
          photoAttachments:photos
        }
        activity.gpsActivityPhotos.push(gpsActivityPhoto);
      }
      return response;
    } catch (error) {
      console.log('check error', error);
      if (error.status === 0) {
        let message = payload.indskr_gpscheckindetailsid ? 'CHECK_OUT_FAILED' : 'CHECK_IN_FAILED';
        this.notificationService.notify(this.translate.instant(message), 'Check In', 'top', ToastStyle.DANGER, 3000);
      }
      return false;
    }
  }


  /**
   * Leverage offline upload service to crud multiple meetings online
   */
  async crudMeetingsOnlineWithOfflineUploadEndpoint(meetings: AppointmentActivity[], refreshAgendaLater: boolean = false): Promise<boolean> {
    if (
      this.deviceService.isOffline
      || !Array.isArray(meetings)
      || meetings.length <= 0
    ) {
      return false;
    }

    // Run payload sanity check & make request
    let response: any;
    try {
      const DTOs = meetings.map(m => m.DTO);
      
      try {
        DTOs.forEach(this.activityDataService.offlineMeetingPayloadSanityCheck);
      } catch (error) {
        console.error('crudMeetingsOnlineWithOfflineUploadEndpoint: ', error);
        return false;
      }
      const url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.offline.UPLOAD_BULK_MEETING;
      const headers = Endpoints.presentations.FAVOURITE_PRESENTATION_HEADER;
      headers.headers = headers.headers.set('X-SystemUserId', this.authenticationService.user.systemUserID);
      const body = DTOs;
      response = await this.http.put(url, body, headers).toPromise();
    } catch (httpError) {
      console.error('crudMeetingsOnlineWithOfflineUploadEndpoint: ', httpError);
      return false;
    }

    let success = false;
    if (response) {
      success = true;

      // If one of them fails, consider as total failure
      for (const key in response) {
        if (Object.prototype.hasOwnProperty.call(response, key)) {
          const meetingResponse = response[key];
          if (!meetingResponse.hasOwnProperty('activityId') || !meetingResponse.activityId) {
            // Something's wrong
            console.error('crudMeetingsOnlineWithOfflineUploadEndpoint: activityId is missing', response);
            success = false;
          } else if (meetingResponse.hasOwnProperty('errorId')) {
            // Handle Errors
            console.error('crudMeetingsOnlineWithOfflineUploadEndpoint: ', meetingResponse);
            success = false;
          }
        }
      }

      if (success) {
        // Update meeting instances. No DB update.
        for (let i = 0; i < meetings.length; i++) {
          const meeting = meetings[i];
          const meetingResponse = response[meeting.offlineMeetingId];

          const isNewRecord = meeting.ID.includes('offline');

          if (meetingResponse) {
            if (meeting.status === 4 || meeting.state === 2) {
              await this.activityService.removeActivity(meeting);
            } else {
              if (isNewRecord) {
                meeting.ID = meetingResponse.activityId;
                meeting.lastUpdatedTime = 0;
                meeting._id = DB_KEY_PREFIXES.MEETING_ACTIVITY + meetingResponse.activityId;
              }

              await this.activityService.addActivity(meeting, true);
            }
          } else {
            console.error('crudMeetingsOnlineWithOfflineUploadEndpoint: meetingRespons is missing: ', meeting, response);
          }
        }

        for (const meeting of meetings) {
          const rawDoc = meeting.DTO;
          await this.disk.updateOrInsert(meeting._id, doc => rawDoc);
        }
      }
    }
    this.activityService.finalizeAgendaRefresh();

    return success;
  }

  async updateAccountToAccountVisit(
    accountVisit: AppointmentActivity,
    oldAccounts: Account[],
    loader,
  ): Promise<boolean> {
    let oldSubject = accountVisit.subject;
    let oldContacts = accountVisit.contacts;
    let origAppointmentActivity: AppointmentActivity;
    let needToRevert = false;
    let success = false;
    const nestedMeetings: AppointmentActivity[] = this.activityService.getAccountVisitNestedMeetings(accountVisit.ID);
    const hadAccountAndContactsBefore = Array.isArray(oldAccounts)
      && oldAccounts.length > 0
      && Array.isArray(accountVisit.contactAttendees)
      && Array.isArray(nestedMeetings)
      && nestedMeetings.length > 0;

    if (hadAccountAndContactsBefore) {
      const hasAnyCompletedAccountVisitNestedMeeting = this.activityService.hasAnyCompletedAccountVisitNestedMeeting(accountVisit);
      if (hasAnyCompletedAccountVisitNestedMeeting) {
        // Revert account
        this.notificationService.notify(
          this.translate.instant('ACCOUNT_VISIT_HAS_COMPLETED_NESTED_MEETING_ACCOUNT_CHANGE_MESSAGE'),
          'AccountVisit',
          'top',
          ToastStyle.DANGER,
        );
        accountVisit.accounts = oldAccounts;
        return false;
      }

      // Check if nested meetings are scrap-able
      const scrapStatusResponse = this.activityService.getAccountVisitNestedMeetingsScrapStatus(nestedMeetings, true);
      // Also block if any nested meeting has a submitted SDR (OMNI-61272) —
      // same protection as a completed Sample Drop, above.
      const hasSubmittedSdrOnNestedMeeting = nestedMeetings.some(
        m => this.sampleDeliveryRequestService.hasSdrForMeeting(m.ID)
      );
      if (hasSubmittedSdrOnNestedMeeting) {
        this.notificationService.notify(
          this.translate.instant('DRAFT_MEETING_HAS_SUBMITTED_SDR_SCRAP_MESSAGE'),
          'ActivityScrap',
        );
      }
      if (scrapStatusResponse.shouldHalt || hasSubmittedSdrOnNestedMeeting) {
        // Revert account
        accountVisit.accounts = oldAccounts;
        return false;
      }

      // Alert user about nested meeting deletion and get confirm
      await this.uiService.dismissLoader();
      const response = await this.alertService.showAlert(
        {
          title: this.translate.instant('CHANGE_ACCOUNT'),
          message: this.translate.instant('ACCOUNT_VISIT_NESTED_MEETING_WILL_BE_SCRAPPED_CONFIRM'),
        },
        this.translate.instant('CONFIRM'),
      );
      if (
        !response
        || response.role !== 'ok'
      ) {
        // Revert account
        accountVisit.accounts = oldAccounts;
        return;
      }
      await this.uiService.displayLoader();
    }

    // Update subject
    const newAccount = Array.isArray(accountVisit?.accounts) && accountVisit.accounts[0];
    if (newAccount) {
      let newSubject = [newAccount.accountName, this.translate.instant('ACCOUNT_VISIT'), accountVisit.activityTypeName].filter(Boolean).join(' - ');
      accountVisit.subject = newSubject;
      origAppointmentActivity = this.activityService.getActivityByID(accountVisit.ID) as AppointmentActivity;
      if (origAppointmentActivity) {
        origAppointmentActivity.subject = newSubject;
      }
    } else {
      accountVisit.subject = [this.translate.instant('ACCOUNT_VISIT'), accountVisit.activityTypeName].filter(Boolean).join(' - ');
    }

    // Prep payload
    const payload: AppointmentActivity[] = [accountVisit];

    // If account visit already has nested meetings, need to remove contacts & scrap nested meetings
    if (hadAccountAndContactsBefore) {
      // Remove contacts from account visit
      accountVisit.contacts = [];

      // Scrap nested appointments
      payload.push(
        ...nestedMeetings.map(a => {
          return new AppointmentActivity({
            _id: a._id ?? DB_KEY_PREFIXES.MEETING_ACTIVITY + a.ID,
            _rev: a._rev ?? undefined,
            activityid: a.ID,
            offlineMeetingId: a.offlineMeetingId,
            subject: a.subject,
            scheduledstart: a.scheduledStart,
            scheduledend: a.scheduledEnd,
            indskr_parentcallid: a.indskr_parentcallid,
            stateCode: 2,
          });
        })
      );
    }

    try {
      success = await this.crudMeetingsOnlineWithOfflineUploadEndpoint(payload);
      needToRevert = !success;
    } catch (error) {
      console.error('updateAccountToAccountVisit: ', error);
    }

    // If request failed and need to revert changes
    if (needToRevert) {
      accountVisit.accounts = oldAccounts;
      accountVisit.subject = oldSubject;
      if (origAppointmentActivity) {
        origAppointmentActivity.subject = oldSubject;
      }
      if (oldContacts) {
        accountVisit.contacts = oldContacts;
      }
    }

    return success;
  }

  public async scrapAccountVisit(activity: AppointmentActivity): Promise<boolean> {
    let success = false;

    const payload: AppointmentActivity[] = [];
    if (activity.indskr_isparentcall) {
      // Parent Account Visit
      // Scrap parent
      payload.push(new AppointmentActivity({
        _id: activity._id ?? DB_KEY_PREFIXES.MEETING_ACTIVITY + activity.ID,
        _rev: activity._rev ?? undefined,
        activityid: activity.ID,
        offlineMeetingId: activity.offlineMeetingId,
        subject: activity.subject,
        scheduledstart: activity.scheduledStart,
        scheduledend: activity.scheduledEnd,
        indskr_isparentcall: true,
        stateCode: 2,
      }));

      const nestedMeetings = this.activityService.getAccountVisitNestedMeetings(activity.ID);
      if (
        Array.isArray(nestedMeetings)
        && nestedMeetings.length > 0
      ) {
        // Scrap children
        payload.push(
          ...nestedMeetings.map(a => {
            return new AppointmentActivity({
              _id: a._id ?? DB_KEY_PREFIXES.MEETING_ACTIVITY + a.ID,
              _rev: a._rev ?? undefined,
              activityid: a.ID,
              offlineMeetingId: a.offlineMeetingId,
              subject: a.subject,
              scheduledstart: a.scheduledStart,
              scheduledend: a.scheduledEnd,
              indskr_parentcallid: a.indskr_parentcallid,
              stateCode: 2,
            });
          })
        );
      }
    } else if (activity.indskr_parentcallid) {
      // Scrap nested meeting
      payload.push(
        new AppointmentActivity({
          _id: activity._id ?? DB_KEY_PREFIXES.MEETING_ACTIVITY + activity.ID,
          _rev: activity._rev ?? undefined,
          activityid: activity.ID,
          offlineMeetingId: activity.offlineMeetingId,
          subject: activity.subject,
          scheduledstart: activity.scheduledStart,
          scheduledend: activity.scheduledEnd,
          indskr_parentcallid: activity.indskr_parentcallid,
          stateCode: 2,
        })
      );

      // Remove contact from parent
      // Since the crud function requires fully loaded activity object as payload,
      // we have to make sure to append the meeting details to the activity object.
      const parent = await this.activityDataService
        .getNewDetailAppendedAppointmentActivityInstanceFromLocalDB(activity.indskr_parentcallid);
      if (
        !parent
        || !parent.contacts
      ) {
        console.error('scrapAccountVisit: Could not find the parent account visit or contact is not available.', activity, parent);
        return success;
      }

      // ! meed 
      const contact = Array.isArray(activity.contacts) ? activity.contacts[0] : undefined;
      if (contact) {
        const contactIdx = parent.contacts?.findIndex(c => c.ID === contact.ID) ?? -1;
        if (contactIdx >= 0) {
          parent.contacts.splice(contactIdx, 1);
        }
      }
      payload.unshift(parent);
    } else {
      console.error('scrapAccountVisit: not an account visit?', activity);
    }

    try {
      if (this.deviceService.isOffline) {
        //In Home screen, if we dont allow this there is no way to come of the screen : user will be blocked
        for (let meeting of payload) {
          await this.activityService.upsertMeetingsOfflineData(meeting);
        }
        success = true;
      } else {
        success = payload.length > 0 ? await this.crudMeetingsOnlineWithOfflineUploadEndpoint(payload) : false;
      }
    } catch (error) {
      console.error('scrapAccountVisit: ', error);
    }

    return success;
  }

  async updateContactToAccountVisit(accountVisit: AppointmentActivity, oldContacts: Contact[]): Promise<boolean> {
    let success = false;
    const newContacts = accountVisit.contacts ?? [];
    const xorContacts = xorBy(newContacts, oldContacts, 'ID');
    const contactsToAdd = intersectionBy(xorContacts, newContacts, 'ID');
    const contactsToRemove = intersectionBy(xorContacts, oldContacts, 'ID');

    // Prep payload
    const payload: AppointmentActivity[] = [accountVisit];
    const accountVisitDTO: any = accountVisit.DTO;
    const newNestedMeetings: AppointmentActivity[] = [];
    if (contactsToAdd.length > 0) {
      // Create new nested meetings
      const timestamp = new Date().getTime();
      for (let i = 0; i < contactsToAdd.length; i++) {
        const contact = contactsToAdd[i];
        // Inherit some fields from account visit
        const newRawMeeting = {
          offlineMeetingId: this.activityService.generateOfflineMeetingId(),
          activitytypecode: 'appointment',
          activityAccounts: accountVisitDTO.activityAccounts,
          activityAccountPlans: accountVisitDTO.activityAccountPlans,
          activityAccompaniedUsers: accountVisitDTO.activityAccompaniedUsers,
          activityAttachments: accountVisitDTO.activityAttachments,
          activityPlaylists: accountVisitDTO.activityPlaylists,
          activityProcedures: accountVisitDTO.activityProcedures,
          activityProducts: accountVisitDTO.activityProducts,
          activityObjectives: accountVisitDTO.activityObjectives,
          activityOpportunities: accountVisitDTO.activityOpportunities,
          activityTherapeuticAreas: accountVisitDTO.activityTherapeuticAreas,
          activityProductIndications : accountVisitDTO.activityProductIndications,
          activityDiseaseAreas : accountVisitDTO.activityDiseaseAreas,
          contactAttendees: [{
            indskr_contactid: contact.ID,
            indskr_name: contact.fullname,
          }],
          indskr_ownerfullname: accountVisitDTO.indskr_ownerfullname,
          indskr_ownerid: accountVisitDTO.indskr_ownerid,
          indskr_jointmeeting: accountVisitDTO.indskr_jointmeeting,
          indskr_notes: accountVisitDTO.indskr_notes,
          accountPlanId : accountVisitDTO.accountPlanId,
          actualend: accountVisitDTO.actualend,
          scheduledend: accountVisitDTO.scheduledend,
          scheduledstart: accountVisitDTO.scheduledstart,
          actualstart: accountVisitDTO.actualstart,
          indskr_iomeetingtype: 100000000,
          indskr_subtype: 100000001,
          indskr_type: 100000000,
          location: accountVisitDTO.location,
          stateCode: 0,
          statuscode: 1,
          subject: accountVisitDTO.subject,
          indskr_activitytype: accountVisitDTO.indskr_activitytype,
          activityTypeName: accountVisitDTO.activityTypeName,
          indskr_positionid: accountVisitDTO.indskr_positionid,
          indskr_isparentcall: false,
          indskr_parentcallid: accountVisitDTO.activityId,
        };
        const newNestedMeeting = new AppointmentActivity(newRawMeeting);
        await this.activityDataService._appendMeetingDetailsToActivity(newNestedMeeting, newRawMeeting);

        newNestedMeetings.push(newNestedMeeting);
        payload.push(newNestedMeeting);
      }
    }
    if (contactsToRemove.length > 0) {
      const nestedMeetingsToBeDeleted: AppointmentActivity[] = [];
      const nestedMeetings = this.activityService.getAccountVisitNestedMeetings(accountVisit.ID);
      // Scrap nested meetings as long as not complete
      for (const contact of contactsToRemove) {
        const nestedMeetingsToDelete = nestedMeetings?.filter(m =>
            Array.isArray(m.contacts)
            && m.contacts[0]?.ID === contact.ID
          );
          if (nestedMeetingsToDelete.length > 0) {
            for(const nestedMeetingToDelete of nestedMeetingsToDelete){
              nestedMeetingsToBeDeleted.push(nestedMeetingToDelete);
              const tempActivityForPayload = new AppointmentActivity({
                _id: nestedMeetingToDelete._id ?? DB_KEY_PREFIXES.MEETING_ACTIVITY + nestedMeetingToDelete.ID,
                _rev: nestedMeetingToDelete._rev ?? undefined,
                activityid: nestedMeetingToDelete.ID,
                offlineMeetingId: nestedMeetingToDelete.offlineMeetingId,
                subject: nestedMeetingToDelete.subject,
                scheduledstart: nestedMeetingToDelete.scheduledStart,
                scheduledend: nestedMeetingToDelete.scheduledEnd,
                indskr_parentcallid: nestedMeetingToDelete.indskr_parentcallid,
                stateCode: 2,
              });
              payload.push(tempActivityForPayload);
            }
          }
      }

      // Check if nested meetings to be deleted are scrap-able
      const scrapStatusResponse = this.activityService.getAccountVisitNestedMeetingsScrapStatus(nestedMeetingsToBeDeleted, true);
      // Also block if any nested meeting has a submitted SDR (OMNI-61272) —
      // same protection as a completed Sample Drop, above.
      const hasSubmittedSdrOnNestedMeeting = nestedMeetingsToBeDeleted.some(
        m => this.sampleDeliveryRequestService.hasSdrForMeeting(m.ID)
      );
      if (hasSubmittedSdrOnNestedMeeting) {
        this.notificationService.notify(
          this.translate.instant('DRAFT_MEETING_HAS_SUBMITTED_SDR_SCRAP_MESSAGE'),
          'ActivityScrap',
        );
      }
      if (scrapStatusResponse.shouldHalt || hasSubmittedSdrOnNestedMeeting) {
        // Revert contacts
        accountVisit.contacts = oldContacts;
        return false;
      }
    }

    try {
      success = await this.crudMeetingsOnlineWithOfflineUploadEndpoint(payload);
    } catch (error) {
      console.error('updateContactToAccountVisit: ', error);
    }

    if (!success) {
      // Revert contacts
      accountVisit.contacts = oldContacts;
    }

    return success;
  }

  async createdNestedAccountVisitWithoutContact(accountVisit: AppointmentActivity): Promise<boolean> {
    let success = false;
    // Prep payload
    const payload: AppointmentActivity[] = [accountVisit];
    const accountVisitDTO: any = accountVisit.DTO;
      // Create new nested meetings
      const timestamp = new Date().getTime();
        const newRawMeeting = {
          offlineMeetingId: this.activityService.generateOfflineMeetingId(),
          activitytypecode: 'appointment',
          activityAccounts: accountVisitDTO.activityAccounts,
          activityAccountPlans: accountVisitDTO.activityAccountPlans,
          activityAccompaniedUsers: accountVisitDTO.activityAccompaniedUsers,
          activityAttachments: accountVisitDTO.activityAttachments,
          activityPlaylists: accountVisitDTO.activityPlaylists,
          activityProcedures: accountVisitDTO.activityProcedures,
          activityProducts: accountVisitDTO.activityProducts,
          activityObjectives: accountVisitDTO.activityObjectives,
          activityOpportunities: accountVisitDTO.activityOpportunities,
          activityTherapeuticAreas: accountVisitDTO.activityTherapeuticAreas,
          indskr_ownerfullname: accountVisitDTO.indskr_ownerfullname,
          indskr_ownerid: accountVisitDTO.indskr_ownerid,
          indskr_jointmeeting: accountVisitDTO.indskr_jointmeeting,
          indskr_notes: accountVisitDTO.indskr_notes,
          accountPlanId : accountVisitDTO.accountPlanId,
          actualend: accountVisitDTO.actualend,
          scheduledend: accountVisitDTO.scheduledend,
          scheduledstart: accountVisitDTO.scheduledstart,
          actualstart: accountVisitDTO.actualstart,
          indskr_iomeetingtype: 100000000,
          indskr_subtype: 100000001,
          indskr_type: 100000000,
          location: accountVisitDTO.location,
          stateCode: 0,
          statuscode: 1,
          subject: accountVisitDTO.subject,
          indskr_activitytype: accountVisitDTO.indskr_activitytype,
          activityTypeName: accountVisitDTO.activityTypeName,
          indskr_positionid: accountVisitDTO.indskr_positionid,
          indskr_isparentcall: false,
          indskr_parentcallid: accountVisitDTO.activityId,
          activityProductIndications : accountVisitDTO.activityProductIndications,
          activityDiseaseAreas : accountVisitDTO.activityDiseaseAreas,
        };
        const newNestedMeeting = new AppointmentActivity(newRawMeeting);
        await this.activityDataService._appendMeetingDetailsToActivity(newNestedMeeting, newRawMeeting);
        payload.push(newNestedMeeting);
    
    try {
      success = await this.crudMeetingsOnlineWithOfflineUploadEndpoint(payload, true);
      
      this.uiService.setUIServiceData({
        view: "new-activity", newNestedMeeting,
      }); // this is an observable stream

      this.activityService.selectedActivityAtHome = this.activityService.selectedActivity = newNestedMeeting;
    } catch (error) {
      console.error('updateContactToAccountVisit: ', error);
    }

    return success;
  }

  getContentId(content: Presentation | Resource) {
    return content['ioPresentationId'] ? content['ioPresentationId'] : (content['ioDocumentId'] ? content['ioDocumentId'] : content['ioResourceId']);
  }

  async addRemoveContentToAccountActivity(
    isAccountVisitRecord: boolean,
    origContents: (Presentation | Resource)[],
    loader,
    skipContentRemoveConfirm = false,
  ) {
    const activity: AppointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
    const payload: AppointmentActivity[] = [activity];
    const nestedMeetings = isAccountVisitRecord ? this.activityService.getAccountVisitNestedMeetings(activity.ID) : [];

    if (
      isAccountVisitRecord
      && Array.isArray(nestedMeetings)
      && nestedMeetings.length > 0
    ) {
      const comparator = (value, other) => {
        if (
          (
            value.ioPresentationId && other.ioPresentationId
            && value.ioPresentationId === other.ioPresentationId
          ) || (
            value.ioResourceId && other.ioResourceId
            && value.ioResourceId === other.ioResourceId
          ) || (
            value.ioDocumentId && other.ioDocumentId
            && value.ioDocumentId === other.ioDocumentId
          )
        ) {
          return true;
        }
      };
      const newContents = activity.presentations;
      const _origContents = Array.isArray(origContents)
      ? origContents
      : [];
      const xorContents = xorWith(
        newContents,
        _origContents,
        comparator,
      );
      const contentToAdd = intersectionWith(
        xorContents,
        newContents,
        comparator,
      );
      const contentToRemove = intersectionWith(
        xorContents,
        _origContents,
        comparator,
      );

      if (contentToRemove.length > 0 && !skipContentRemoveConfirm) {
        await loader?.dismiss();
        // Warn user about nested meeting content remove and get confirm
        const response = await this.alertService.showAlert(
          {
            title: this.translate.instant('MEETING_STRUCTURE_REMOVE_CONTENT_TITLE'),
            message: this.translate.instant('ACCOUNT_VISIT_CONTENT_REMOVE_CONFIRM'),
          },
          this.translate.instant('REMOVE'),
        );

        if (!response || response.role !== 'ok') {
          throw(new Error('ignore'));
        }
        await loader?.present();
        await this.uiService.displayLoader();
      }

      if (contentToAdd.length > 0 || contentToRemove.length > 0) {
        for (let i = 0; i < nestedMeetings.length; i++) {
          const nestedMeeting = nestedMeetings[i];
          if (
            nestedMeeting.state !== 1
            && nestedMeeting._id
          ) {
            try {
              // Need to load full detail..
              const raw = await this.disk.retrieve(nestedMeeting._id, true);
              if (raw) {
                await this.activityDataService._appendMeetingDetailsToActivity(nestedMeeting, raw);

                if (!Array.isArray(nestedMeeting.presentations)) {
                  nestedMeeting.presentations = [];
                }
                const idxToRemove = [];
                for (let i = 0; i < nestedMeeting.presentations.length; i++) {
                  const content = nestedMeeting.presentations[i];
                  const id = this.getContentId(content);
                  if (contentToRemove.length <= 0) {
                    break;
                  }
                  const has = contentToRemove.some((p: any) => {
                    return p.ioPresentationId === id
                      || p.ioResourceId === id
                      || p.ioDocumentId === id
                  });
                  if (has) {
                    idxToRemove.unshift(i);
                  }
                }

                if (idxToRemove.length > 0) {
                  for (let i = 0; i < idxToRemove.length; i++) {
                    const idx = idxToRemove[i];
                    nestedMeeting.presentations.splice(idx, 1);
                  }
                }

                // Add contents to nested meeting
                if (
                  contentToAdd.length > 0
                ) {
                  if (nestedMeeting.presentations.length > 0) {
                    // Don't add duplicate contents
                    const xor = xorWith(
                      contentToAdd,
                      nestedMeeting.presentations,
                      comparator,
                    );
                    const toAdd = intersectionWith(
                      xor,
                      contentToAdd,
                      comparator,
                    );
                    nestedMeeting.presentations.push(...toAdd);
                  } else {
                    nestedMeeting.presentations.push(...contentToAdd);
                  }
                }
                payload.push(nestedMeeting);
              }
            } catch (error) {
              console.error('addRemoveContentToAccountActivity: ', error);
            }
          }
        }
      }
    }

    let success = false;

    if (payload.length > 0) {
      success = await this.crudMeetingsOnlineWithOfflineUploadEndpoint(payload);
    }

    if (!success) {
      throw(new Error('addToAccountActivity: failed to update'));
    }
  }

  /**
   * Function to update meeting location
   * @param meeting 
   * @returns 
   */
  async updateMeetingLocation(meeting: AppointmentActivity) {
    await this.uiService.displayLoader();
    const payload = new UpdateMeetingPayload();
    payload.location = meeting.location;
    payload.indskr_meetinglocationlatitude  = meeting.indskr_meetinglocationlatitude  ?? null;
    payload.indskr_meetinglocationlongitude = meeting.indskr_meetinglocationlongitude ?? null;

    return this.updateMeeting(this.activityService.selectedActivity as AppointmentActivity, payload, true, false, true).then(async () => {
      if (this.activityService.selectedActivity instanceof AppointmentActivity) {
        this.activityService.updateSelectedActivityProps({
          location: meeting.location,
          indskr_meetinglocationlatitude: meeting.indskr_meetinglocationlatitude,
          indskr_meetinglocationlongitude: meeting.indskr_meetinglocationlongitude,
        });
      }
     
      let activity = this.activityService.getActivityByID(this.activityService.selectedActivity.ID);
      if (activity instanceof AppointmentActivity) {
        activity.location = meeting.location;
        activity.indskr_meetinglocationlatitude = meeting.indskr_meetinglocationlatitude;
        activity.indskr_meetinglocationlongitude = meeting.indskr_meetinglocationlongitude;
      }

      this.uiService.dismissLoader();
    }).catch(error => {
        console.error('onCloseModal: ', error);
        this.uiService.dismissLoader();
        this.activityService.upsertMeetingsOfflineData(meeting, false, true);
      });
  }
  
  public async convertToRemoteMeeting() {
    const currentActivity: AppointmentActivity = this.activityService.selectedActivity as AppointmentActivity;
    const meetingFormats = this.activityService.configuredActivityTypes(MeetingActivityTypeCode.MEETING, FormatType.HCP_MEETING);
    if (currentActivity.indskr_activitytype) {
      const existingFormat = meetingFormats.find(mf => mf.indskr_activitytypeid == currentActivity.indskr_activitytype);
      if (existingFormat.indskr_remotechannel) return;
    }
    currentActivity['isRemoteDetailing'] = currentActivity.isRemoteDetailing = true;
    const remoteChannelFormats = meetingFormats.filter(mf => mf.indskr_remotechannel);
    if (remoteChannelFormats.length == 0) return;
    const remoteFormat = remoteChannelFormats[0];
    const defaultActivitySubType = this.activityService.getActivitySubTypesByActivityType(MeetingActivityTypeCode.MEETING, remoteFormat.indskr_activitytypeid).find(ast => ast.indskr_default);
    const payload = {
      indskr_activitytype: remoteFormat.indskr_activitytypeid,
      activityTypeName: this.localisationService.getTranslatedString(remoteFormat.indskr_name, EntityNameForTranslation.ActivityType),
      indskr_activitysubtype: defaultActivitySubType ? defaultActivitySubType.indskr_activitysubtypeid : null,
      activitySubTypeName: defaultActivitySubType ? this.localisationService.getTranslatedString(defaultActivitySubType.indskr_name, EntityNameForTranslation.ActivityType) : null,
      //Subject = HCP Name - Activity - Format - Rep Name
      subject: this.activityService.getAppointmentActivitySubject(currentActivity, remoteFormat.indskr_name),
    };

    await this.updateActivityTypeAndActivitySubType(
      currentActivity,
      payload,
      ActivityTypeCodeRaw.Appointment,
      'indskr_activitytype',
      true,
    );
  }

  async updateContactJoinDetailsLeftDate(activity, useSlideTime: boolean = false) {
    let meeting = activity as AppointmentActivity;
    if (!meeting.isRemoteDetailing || isEmpty(meeting.contacts) || this.deviceService.isOffline) return;
    let leftDate = new Date().getTime();
    if (useSlideTime && !isEmpty(meeting.activityPresentations)) {
      console.log("Updating endtime using slide");
      const slidesShared = meeting.activityPresentations.map(a => a.activityPresentationSlides).reduce((c1, c2) => c1.concat(c2), []);
      const latestSlide = maxBy(slidesShared, (o) => toNumber(o.endtime));
      console.log("Latest slide", latestSlide);
      console.log("Latest slide endTime", latestSlide?.endtime);
      if (latestSlide) {
        leftDate = toNumber(latestSlide?.endtime);
      }
    }
    const payload = meeting.contacts?.map(c => ({ "indskr_contactid": c.ID, "indskr_leftdate": leftDate }));
    let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.activites.UPDATE_CUSTOMER_JOIN_DETAILS_LEFT_DATE;
    url = url.replace('{activityId}', meeting.ID);
    await this.http.patch(url, payload).toPromise();
    await this.updateMeetingDuration(meeting, activity);
  }

  private async updateMeetingDuration(meeting: AppointmentActivity, activity: any) {
    if (this.authenticationService.hasFeatureAction(FeatureActionsMap.CAPTURE_REMOTE_DETAILING_DURATION) && !isEmpty(meeting.contacts)) {
      let fetchXml = fetchQueries.fetchContactJoinDetails;
      fetchXml = fetchXml.replace('{activityId}', activity.ID);
      fetchXml = fetchXml.replace('{contactId}', meeting.contacts[0].ID);
      const activityattendeejoiningdetails = await this.dynamics.executeFetchQuery("indskr_activityattendeejoiningdetails", fetchXml);
      meeting.activityattendeejoiningdetails = (activity as AppointmentActivity).activityattendeejoiningdetails = activityattendeejoiningdetails;
      await this.updateActualDurationInSeconds(meeting, this.activityService.actualDuration);
    }
  }

  async updateActualDurationInSeconds(activity: AppointmentActivity, duration: number) {
    try {
      await this.dynamics.update(activity.ID, "appointments", { indskr_duration: duration });
      await this.disk.updateOrInsertActivityToActivityDetailRawDocument(activity, true);
    } catch (err) {
      console.error("Error while updating remote duration", err);
    }
  }
  
  async getActiveGeneralConsent(contactId: string) {
    let url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.consent.GET_ACTIVE_GENERAL_CONSENT;
    url = url.replace('{contactId}', contactId);
    const response: any = await this.http.get(url).toPromise();
    let activeConsent = response && response.indskr_consentid ? true : false;
    this.events.publish('active-consent', activeConsent);
    return activeConsent;
  }

  private _populateContactSentimentKeyMessages(activity: AppointmentActivity){
    let obj = [];
    let isDirty = false;
    if(this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_KEY_MESSAGE_SENTIMENT) && activity.activityContactSentiments && activity.activityContactSentiments.length){
      activity.activityContactSentiments.forEach(acs=> {
        let oldKeyMessagesList = acs.activityKeyMessageSentiments;
        let uniqueKeyMessagesList = []; 
        if((this.activityService.selectedActivity as AppointmentActivity).products){
          (this.activityService.selectedActivity as AppointmentActivity).products.forEach(p=> {
            if((p.isSelected || p.isAutoSelected) && p.keyMessages){
              p.keyMessages.forEach(k=> {
                if(k.isSelected || k.isAutoSelected){
                  if(!uniqueKeyMessagesList.some(a=> a.indskr_keymessageid == k.ID)){
                    let alreadyPresetObj = oldKeyMessagesList.find(b=> b.indskr_keymessageid == k.ID);
                    isDirty = true;
                    uniqueKeyMessagesList.push({
                      indskr_keymessageid: k.ID.toString(),
                      indskr_name: k.name.toString(),
                      indskr_keymessagesentiment: alreadyPresetObj ? alreadyPresetObj.indskr_keymessagesentiment : 'NEUTRAL',
                    });
                  }
                }
              })
            }
          })
        }
        if((this.activityService.selectedActivity as AppointmentActivity).activityProductIndications){
          (this.activityService.selectedActivity as AppointmentActivity).activityProductIndications.forEach(p=> {
            if(p.activityProductIndicationKeyMessages){
              p.activityProductIndicationKeyMessages.forEach(k=> {
                  if(!uniqueKeyMessagesList.some(a=> a.indskr_keymessageid == k.indskr_keymessageid)){
                    let alreadyPresetObj = oldKeyMessagesList.find(b=> b.indskr_keymessageid == k.indskr_keymessageid);
                    isDirty = true;
                    uniqueKeyMessagesList.push({
                      indskr_keymessageid: k.indskr_keymessageid,
                      indskr_name: k.indskr_name,
                      indskr_keymessagesentiment: alreadyPresetObj ? alreadyPresetObj.indskr_keymessagesentiment : 'NEUTRAL',
                    });
                  }
              })
            }
          })
        }
        if(isDirty){
          uniqueKeyMessagesList = uniqueKeyMessagesList.sort((a,b) => {
            let c = a['indskr_name'].toLowerCase();
            let d = b['indskr_name'].toLowerCase();
            if (c < d)
                return -1;
            if (c > d)
                return 1;
            return 0;
          });
          let contact = activity.contacts.find(c=> c.ID == acs.indskr_contactid);
          if(contact){
            let conObj = {
              indskr_contactid: contact.ID,
              indskr_name: contact.fullName.trim(),
              indskr_isguest: contact.isguest,
              indskr_joinstatus: contact.connectionState,
              indskr_isremote: contact.isremote,
              indskr_leftmanually: contact.isleftmanually,
              indskr_sequence: contact.indskr_sequence,
            };
            if (contact.join_date && contact.join_date != "" && contact.join_date != "null") {
              conObj['indskr_joineddate'] = this.dateTimeFormatsService.isValidDate(new Date(contact.join_date)) ? this.dateTimeFormatsService.formatDate(contact.join_date, 'YYYY-MM-DDTHH:mm:ssZ') : this.dateTimeFormatsService.formatDate(parseFloat(contact.join_date), 'YYYY-MM-DDTHH:mm:ssZ');
            }
            if (contact.left_date && contact.left_date != "" && contact.left_date != "null") {
              conObj['indskr_leftdate'] = this.dateTimeFormatsService.isValidDate(new Date(contact.left_date)) ? this.dateTimeFormatsService.formatDate(contact.left_date, 'YYYY-MM-DDTHH:mm:ssZ') : this.dateTimeFormatsService.formatDate(parseFloat(contact.left_date), 'YYYY-MM-DDTHH:mm:ssZ');
            }
            conObj['activityKeyMessageSentiments'] = uniqueKeyMessagesList;
            acs.activityKeyMessageSentiments = uniqueKeyMessagesList;
            obj.push(conObj)
          }
        }
      })
    }
    return obj;
  }

  public async createMeetingFromShortCallHome(account: Account, contact: Contact, presentation: Presentation, ecard: boolean, accountLocation: string, accountCoordinates: LocationCoordinates) {
    const start = new Date().getTime();
    const meetingDuration = ecard ? 5 : this.authenticationService.user?.meeting_duration || 30;
    const end = this.dateTimeFormatsService.addMinutesToDate(start, meetingDuration).getTime();
    const subject = `${contact.fullName} - ${this.translate.instant('SHORT_MEETING')}`;
    const location = accountLocation ?? '';
    const shortCallPayload = new InitiateMeetingPayload(subject, location, start, end, '', this.activityService.generateOfflineMeetingId(), '', ecard);
    const newMeeting = await this.createNewMeeting(shortCallPayload, contact.fullName);
    if (accountCoordinates) {
      newMeeting.indskr_meetinglocationlongitude = accountCoordinates.longitude;
      newMeeting.indskr_meetinglocationlatitude = accountCoordinates.latitude;
    }
    this.activityService.selectedActivity = newMeeting;
    this.accountService.moveAccountToSelected(account);
    this.activityService.selectedActivity['contacts']= [contact];
    this.activityService.selectedActivity['presentations'] = [presentation];
    let shortcall = this.activityService.selectedActivity as AppointmentActivity;
    Promise.all([
      this.addAccountsToMeeting(shortcall),
      this.addContactsToMeeting(shortcall, true),
      this.addContentToMeeting(shortcall.presentations, shortcall)
    ]).then(async (data) => {
      if (Array.isArray(data) && data.length == 3 && data[1] == false) {
        await this.activityService.upsertMeetingsOfflineData(shortcall, false, true);
      }
    }).catch(async err => {
      console.error('createMeetingFromShortCallHome: onAddingMeetingDetails: ', err);
      await this.activityService.upsertMeetingsOfflineData(shortcall, false, true);
    });
    await this.disk.updateOrInsertActivityToActivityDetailRawDocument(shortcall);
  }



  async generateMeetingUrl(meetingId){
    let url = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.GENERATE_MEETING_URL;
    url = url.replace('{meetingId}', meetingId);
    let headers = new HttpHeaders();
    headers = headers.set(
      "X-BusinessUnitId",
      this.authenticationService.user.xBusinessUnitId
    );
    const response: any = await this.http.put(url,{},{headers}).toPromise();
    return response;
  }

  async assignOwner(payload, meetingId) : Promise<boolean> {
    try {
      let url = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.ASSIGN_MEETING_OWNER;
      url = url.replace('{activityId}', meetingId);
      await this.http.patch(url, payload).toPromise();
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  async updateMeetingMarketingBusinessPlanOffline(meetingId, marketingBusinessPlan){
    let activity = this.activityService.activities.find(item => item.ID === meetingId) as AppointmentActivity;
    activity.marketingBusinessPlanId = marketingBusinessPlan.ID ? marketingBusinessPlan.ID : "";
    activity.marketingBusinessPlanName = marketingBusinessPlan.brandPlanName ? marketingBusinessPlan.brandPlanName : "";
    await this.activityService.upsertMeetingsOfflineData(activity);
  }

  async updateMeetingCoachingPlanOffline(meetingId, coachingPlan){
    let activity = this.activityService.activities.find(item => item.ID === meetingId) as AppointmentActivity;
    activity.indskr_coachingplan = coachingPlan && coachingPlan.id ? coachingPlan.id : "";
    activity.indskr_coachingplanname = coachingPlan && coachingPlan.primaryTextRight ? coachingPlan.primaryTextRight : "";
    await this.activityService.upsertMeetingsOfflineData(activity);
  }

  async updateMeetingMarketingBusinessPlanOnline(mode, payload, meetingId) {
    try {
      let url = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.UPDATE_MEETING_MARKETING_BUSINESS_PLAN;
      url = url.replace('{activityId}', meetingId);
      if (mode === 'Delete') {
        const options = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
          body: payload
        };
        await this.http.delete(url, options).toPromise();
      } else {
        await this.http.patch(url, payload).toPromise();
      }
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  async updateMeetingCoachingPlanOnline(payload, meetingId) {
    try {
      let url = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.UPDATE_MEETING_COACHING_PLAN;
      url = url.replace('{activityId}', meetingId);
      await this.http.patch(url, payload).toPromise();
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }
  async recordShortCallContentShare(presentation: Presentation, activityId: string, contactId: string) {
    if (!presentation || !activityId || !contactId) {
      return;
    }
    const url = this.authenticationService.userConfig.activeInstance.entryPointUrl
      + Endpoints.meeting.CONTENT_SHARE.replace(
        '{activity_id}',
        activityId,
      );
    const payload = {
      indskr_contactid: contactId,
      indskr_iopresentationid: presentation.contentId,
      indskr_startdate: '' + new Date().getTime(),
      indskr_contenttype: ActivityContentShareTypeOptionSetValue.ShareContentLinkToMessagingApp,
      indskr_presentationlink: presentation.indskr_externalcontentlink,
      indskr_user: this.authenticationService.user.xSystemUserID,
      indskr_name: presentation.name
    };
    const headers = Endpoints.headers.content_type.json;
    try {
      await this.http.post(url, payload, headers).toPromise();
    } catch (error) {
      console.error('recordShortCallContentShare: ', error);
    }
  }

  async appendMeetingLatAndLongForGpsDistanceCalculation(activity: AppointmentActivity) {
    if (
      this.authenticationService.user.buSettings
      && this.authenticationService.user.buSettings['indskr_capturegpsdistanceaccountwhencontentplaye']
      && (
        !activity.indskr_meetinglocationlongitude
        || !activity.indskr_meetinglocationlatitude
      )
    ) {
      const account = Array.isArray(activity?.accounts) && activity?.accounts[0] ? activity.accounts[0] : undefined;
      if (account) {
        const selectedAccountAddress = await this.accountService.getPrimaryAddressOfAccount(account.id);
        if (selectedAccountAddress) {
          activity.indskr_meetinglocationlongitude = selectedAccountAddress.longitude;
          activity.indskr_meetinglocationlatitude = selectedAccountAddress.latitude;
        }
      }
    }
  }

  toastNotification(data, notification) {
    if (notification == 'fromContact') {
      this.notificationService.notify(`${data.fullname} ${this.translate.instant("ACCOUNT_AND_CONTACT_NOTIFICATION_FOR_MEETING")}`, "");
      return;
    } else if (notification == 'fromAccount') {
      this.notificationService.notify(`${data.accountName} ${this.translate.instant("ACCOUNT_AND_CONTACT_NOTIFICATION_FOR_MEETING")}`, "");
      return;
    }
  }



  // ===== new ui related api calls ===== //

  setMeetingSubject(meeting) {
    if (this.secondaryInfoService.isAppointmentSecInfoConfigured) {
      const subject = this.secondaryInfoService.getSecondaryInfoFormatedTextForAppointment(meeting, SecondaryInfoEntityName.Appointment);
      return subject;
    } else if (this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)) {
      meeting.subject = [this.translate.instant('MEETING'), meeting.activityTypeName, meeting.meetingOwnerName].filter(Boolean).join(" - ");
      const subject = this.getMeetingSubject(meeting);
      return subject;
    }

    return meeting.subject;
  }

  /**
   * Re-derive and persist the configurable-summary (secondary-info) subject after
   * affiliated accounts/contacts/products have been attached to a freshly created
   * meeting (e.g. a clone).
   *
   * createNewMeeting builds the secondary-info subject before those entities exist
   * on the meeting, so the account/contact name segments are silently dropped by
   * the formatter's filter(Boolean) - leaving subjects like
   * "Appointments / Face-2-face / @2026" (OMNI-60513 for drag-create, OMNI-60713 for clone).
   * The account/contact tools and drag handlers already recompute once everything is
   * attached; the clone path had no equivalent.
   *
   * No-op unless appointment secondary-info is configured, and skips persistence
   * when the recomputed subject is unchanged.
   */
  public async recomputeSecInfoSubjectAfterAttach(meeting: AppointmentActivity): Promise<void> {
    if (!this.secondaryInfoService.isAppointmentSecInfoConfigured) {
      return;
    }
    const recomputedSubject = this.setMeetingSubject(meeting);
    if (!recomputedSubject || recomputedSubject === meeting.subject) {
      return;
    }
    meeting.subject = recomputedSubject;
    if (!this.deviceService.isOffline && !this.activityService.hasOfflineMeetingData(meeting.ID)) {
      const subjectPayload = new UpdateMeetingPayload(
        meeting.subject,
        meeting.location,
        meeting.scheduledStart,
        meeting.scheduledEnd,
      );
      try {
        // updateMeetingType MUST be true here — updateMeeting only rethrows an
        // HTTP failure to its caller when this flag is set (see its own catch
        // block); left at the default false, a failed PATCH is swallowed by
        // GlobalErrorHandler.handleError (logs, never rethrows), so this
        // method's own catch below — the offline-retry safety net — never
        // fires. That left the recomputed subject persisted only in memory:
        // never locally saved, never queued for retry, silently reverted by
        // the next sync pulling the still-wrong server value back down.
        await this.updateMeeting(meeting, subjectPayload, true);
      } catch (error) {
        // Subject patch failure must not blow away the meeting; queue offline-pending
        // so the next sync retries the subject update.
        console.error('recomputeSecInfoSubjectAfterAttach: secondary-info subject update failed', error);
        await this.activityService.upsertMeetingsOfflineData(meeting, false, true);
      }
    } else {
      await this.activityService.upsertMeetingsOfflineData(meeting);
    }
  }

  setMeetingSubjectFromContact(meeting, ownerName) {
    const isAcinoBaseUser = this.authenticationService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT);
    const isAutoSubjectEnabled = this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT);

    if (this.secondaryInfoService.isAppointmentSecInfoConfigured
      && this.secondaryInfoService.checkIfSchemaIsConfig('indskr_contactid', SecondaryInfoEntityName.Appointment)) {
      const subject = this.secondaryInfoService.getSecondaryInfoFormatedTextForAppointment(meeting, SecondaryInfoEntityName.Appointment);
      if (this.activityService.selectedActivity.subject !== subject) {
        this.activityService.updateSelectedActivityProps({ subject });
      }
    } else if (isAutoSubjectEnabled || isAcinoBaseUser) {
      let subject: string = this.translate.instant('MEETING');
      let subPrefix = ` - ${subject} - ${meeting.activityTypeName ? meeting.activityTypeName + ' - ' : ' '} ${ownerName}`;
      const selectedContacts = Array.isArray(meeting.contacts)
        ? meeting.contacts
        : [];
      if (isAcinoBaseUser) {
        subject = `${meeting.activityTypeName ? meeting.activityTypeName + ' ' : ''}${this.translate.instant('VISIT')}`;
      }
      switch (selectedContacts.length) {
        case 0:
          if (!isAcinoBaseUser)
            subject = `${this.translate.instant('MEETING')} - ${meeting.activityTypeName ? meeting.activityTypeName + ' - ' : ' '} ${ownerName}`;
          break;
        case 1:
          subject = `${this.contactService.getFullNameForContactDisplaySequence(selectedContacts[0])}${subPrefix}`;
          if (isAcinoBaseUser) {
            subject = `${meeting.activityTypeName ? meeting.activityTypeName + ' ' : ''}${this.translate.instant('VISIT')} - ${this.contactService.getFullNameForContactDisplaySequence(selectedContacts[0])}`;
          }
          break;
        default:
          if (selectedContacts.length > 1) {
            if (!this.contactService.isMeetingContactSequenceEnabled) {
              selectedContacts.sort((contactA, contactB): number => {
                let contactAFullName = (contactA.firstName.length > 0) ? contactA.firstName + " " + contactA.lastName : contactA.lastName;
                let contactBFullName = (contactB.firstName.length > 0) ? contactB.firstName + " " + contactB.lastName : contactB.lastName;
                if (contactAFullName.toLowerCase() > contactBFullName.toLowerCase()) return 1;
                if (contactAFullName.toLowerCase() < contactBFullName.toLowerCase()) return -1;

                return 0;
              });
            } else {
              selectedContacts.sort((contactA, contactB) => {
                return contactA.indskr_sequence - contactB.indskr_sequence;
              });
            }
            subject = `${this.contactService.getFullNameForContactDisplaySequence(selectedContacts[0])} + ${selectedContacts.length - 1}${subPrefix}`;
            if (isAcinoBaseUser) {
              subject = `${meeting.activityTypeName ? meeting.activityTypeName + ' ' : ''}${this.translate.instant('VISIT')} - ${this.contactService.getFullNameForContactDisplaySequence(selectedContacts[0])}`;
            }
          }
      }
      if (this.activityService.selectedActivity.subject !== subject) {
        this.activityService.updateSelectedActivityProps({ subject });
      }
    }
  }

  async updateMeetingWithAccounts(action: String, accountsToUpdate: Account) {
    await this.uiService.displayLoader();
    let affiliatedContact: Contact;
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const currentUser = this.authenticationService.user;
    let meetingSubjectUpdate = false;
    const isAcinoBaseUser = this.authenticationService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT);
    const isAutoSubjectEnabled = this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT);
    let locationAutoPopulated = false; // Track if location was auto-populated (OMNI-53277)
    
    if (action === 'add') {

      if (meeting.accounts.length === 0 && meeting.contacts.length === 0) {
        const affiliatedContacts = await this.contactService.getAffiliatedContactsFromAccountsForMeeting([accountsToUpdate]);
        if (affiliatedContacts.length === 1) {
          affiliatedContact = affiliatedContacts[0];
        }
      }

      this.accountService.moveAccountToSelected(accountsToUpdate);

      if (affiliatedContact) {
        this.contactService.moveContactToSelected(affiliatedContact);

        if (this.activityService.selectedActivity.location !== "LiveMeet") {
          if (!this.authenticationService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) || (this.authenticationService.user.buConfigs && this.authenticationService.user.buConfigs['indskr_populateaccountaddress'])) {
            const previousLocation = meeting.location;
            await this.contactService.setLocationField(affiliatedContact);
            // Fix OMNI-53277: Track if location was actually changed by setLocationField
            if (meeting.location !== previousLocation) {
              locationAutoPopulated = true;
            }
          }
        }
      }

      if ((this.authenticationService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) || 
           this.authenticationService.hasFeatureAction(FeatureActionsMap.CAPTURE_GPS_DISTANCE_FROM_CONTACT) ||
           (this.authenticationService.user.buConfigs && this.authenticationService.user.buConfigs['indskr_populateaccountaddress'])) && 
           !this.activityService.isRemoteChannelEnabled((this.activityService.selectedActivity as AppointmentActivity).indskr_activitytype)) {
        const previousLocation = meeting.location;
        await this.addAccountAddressToMeeting();
        // Fix OMNI-53277: Track if location was changed by addAccountAddressToMeeting
        if (meeting.location !== previousLocation) {
          locationAutoPopulated = true;
        }
      }

      meetingSubjectUpdate = this.secondaryInfoService.checkIfSchemaIsConfig('indskr_accountid', SecondaryInfoEntityName.Appointment) ||
      (affiliatedContact && this.secondaryInfoService.checkIfSchemaIsConfig('indskr_contactid', SecondaryInfoEntityName.Appointment));

      const previousSubjectOnAdd = meeting.subject;
      this.setMeetingSubjectFromContact(meeting, meeting.meetingOwnerName);
      if (this.secondaryInfoService.isAppointmentSecInfoConfigured && meetingSubjectUpdate) {
        meeting.subject = await this.setMeetingSubject(meeting);
      }

      const shouldCallApiForAccounts = this._shouldCallMeetingApi(meeting.ID);

      if (shouldCallApiForAccounts) {
        try {
          // Fix OMNI-53277: Always update if subject OR location changed to ensure location syncs to Dynamics
          if ((this.secondaryInfoService.isAppointmentSecInfoConfigured && meetingSubjectUpdate) ||
              isAutoSubjectEnabled ||
              isAcinoBaseUser ||
              locationAutoPopulated) {
            const payload = new UpdateMeetingPayload();
            if (meeting.subject !== previousSubjectOnAdd) payload.subject = meeting.subject;
            if (locationAutoPopulated) {
              payload.location = meeting.location;
              payload.indskr_meetinglocationlatitude  = meeting.indskr_meetinglocationlatitude  ?? null;
              payload.indskr_meetinglocationlongitude = meeting.indskr_meetinglocationlongitude ?? null;
            }
            if (Object.keys(payload.getRequestBody()).length > 0) {
              this.updateMeeting(meeting, payload);
            }
          }
          const response: any = await this.appendAccountsToMeeting(meeting.ID, [accountsToUpdate]);

          if ((this.authenticationService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) || 
               this.authenticationService.hasFeatureAction(FeatureActionsMap.CAPTURE_GPS_DISTANCE_FROM_CONTACT) ||
               (currentUser.buConfigs && currentUser.buConfigs['indskr_populateaccountaddress'])) && 
               !this.activityService.isRemoteChannelEnabled(meeting.indskr_activitytype)) {
            this.updateMeetingLocation(meeting);
          }

          if (affiliatedContact) {
            const response = await this.appendContactsToMeeting(meeting.ID, [affiliatedContact]);
            let activityContacts = meeting._raw_contactAttendees;
            if (activityContacts) {
              activityContacts = [...activityContacts, ...response];
            } else {
              activityContacts = [...response];
            }
            meeting._raw_contactAttendees = activityContacts;
          }

          let activityAccounts = meeting._raw_activityAccounts;
          if (activityAccounts) {
            activityAccounts = [...activityAccounts, ...response];
          } else {
            activityAccounts = [...response];
          }

          meeting._raw_activityAccounts = activityAccounts;
          this.updateActivities(meeting);
          await this.activityService.upsertMeetingsOfflineData(meeting);
          await this.uiService.dismissLoader();
        } catch (error) {
          await this.uiService.dismissLoader();
          await this.activityService.upsertMeetingsOfflineData(meeting, false, true);
        }
      } else {
        await this.activityService.upsertMeetingsOfflineData(meeting);
        await this.uiService.dismissLoader();
      }

    } else if (action === 'remove') {
      let contactToRemove;

      meeting.accounts = meeting.accounts.filter((account) => account.id !== accountsToUpdate.id);

      if ((this.authenticationService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) || 
           this.authenticationService.hasFeatureAction(FeatureActionsMap.CAPTURE_GPS_DISTANCE_FROM_CONTACT) ||
           (currentUser.buConfigs && currentUser.buConfigs['indskr_populateaccountaddress'])) && 
           !this.activityService.isRemoteChannelEnabled(meeting.indskr_activitytype)) {
        await this.addAccountAddressToMeeting() // this is used to reset the location as well
      }

      if (contactToRemove) {
        meeting.contacts = meeting.contacts.filter((con) => con.ID !== contactToRemove.ID);
      }

      meetingSubjectUpdate = this.secondaryInfoService.checkIfSchemaIsConfig('indskr_accountid', SecondaryInfoEntityName.Appointment) ||
      (affiliatedContact && this.secondaryInfoService.checkIfSchemaIsConfig('indskr_contactid', SecondaryInfoEntityName.Appointment));

      const previousSubjectOnRemove = meeting.subject;
      this.setMeetingSubjectFromContact(meeting, meeting.meetingOwnerName);

      if (meetingSubjectUpdate && this.secondaryInfoService.isAppointmentSecInfoConfigured) {
        meeting.subject = await this.setMeetingSubject(meeting);
      }

      const shouldCallApiForAccountRemove = this._shouldCallMeetingApi(meeting.ID);

      if (shouldCallApiForAccountRemove) {
        try {
          const response: any = await this.removeAccountsFromMeeting(this.activityService.selectedActivity.ID, [accountsToUpdate]);
          meeting._raw_activityAccounts = this.removeRawActivityAccounts(meeting, accountsToUpdate.id);
          if (contactToRemove) {
            await this.removeContactsFromMeeting(meeting.ID, [contactToRemove]);
            meeting._raw_contactAttendees = this.removeRawContactAttendies(meeting, contactToRemove.ID);
          }

          if ((this.authenticationService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) ||
               this.authenticationService.hasFeatureAction(FeatureActionsMap.CAPTURE_GPS_DISTANCE_FROM_CONTACT) ||
               (currentUser.buConfigs && currentUser.buConfigs['indskr_populateaccountaddress'])) &&
               !this.activityService.isRemoteChannelEnabled(meeting.indskr_activitytype)) {
            this.updateMeetingLocation(meeting); // now sends only location + lat/lng
          }

          if ((this.secondaryInfoService.isAppointmentSecInfoConfigured && meetingSubjectUpdate) || isAutoSubjectEnabled || isAcinoBaseUser) {
            if (meeting.subject !== previousSubjectOnRemove) {
              const payload = new UpdateMeetingPayload();
              payload.subject = meeting.subject;
              this.updateMeeting(meeting, payload);
            }
          }

          await this.uiService.dismissLoader();
          await this.activityService.upsertMeetingsOfflineData(meeting);
        } catch (error) {
          await this.uiService.dismissLoader();
          await this.activityService.upsertMeetingsOfflineData(meeting, false, true);
        }
      } else {
        await this.uiService.dismissLoader();
        await this.activityService.upsertMeetingsOfflineData(meeting);
      }
    }
  }

  async addAccountAddressToMeeting() {
    if (this.activityService.selectedActivity instanceof AppointmentActivity) {
      let meeting = this.activityService.selectedActivity;
      if (this.activityService.selectedActivity['accounts'].length != 0) {
        const selectedAddress = await this.accountService.getPrimaryAddressOfAccount(this.activityService.selectedActivity['accounts'][0].id);
        if (selectedAddress) {
          meeting.location = selectedAddress.compositeAdd;
          meeting.indskr_meetinglocationlongitude = selectedAddress.longitude ? selectedAddress.longitude : null;
          meeting.indskr_meetinglocationlatitude = selectedAddress.latitude ? selectedAddress.latitude : null;
        } else {
          meeting.location = '';
          meeting.indskr_meetinglocationlongitude = null;
          meeting.indskr_meetinglocationlatitude = null;
        }
      }
    }
  }

  async updateMeetingWithContacts(action: String, contactToUpdate: Contact) {
    await this.uiService.displayLoader();
    let affiliatedAccount: Account;
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    const currentUser = this.authenticationService.user;
    let meetingSubjectUpdate = false;
    const isAcinoBaseUser = this.authenticationService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT);
    const isAutoSubjectEnabled = this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT);
    let locationAutoPopulated = false; // Track if location was auto-populated (OMNI-53277)

    const hideAccountField = this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_APPOINTMENT_GA_HIDE_ACCOUNT_FIELD) as boolean;

    if (action === 'add') {

      if (!hideAccountField && meeting.accounts.length === 0 && meeting.contacts.length === 0) {
        const affiliatedAccounts = await this.accountService.getAffiliatedAccountsFromSelectedContactsForMeeting([contactToUpdate]);
        if (affiliatedAccounts.length === 1) {
          affiliatedAccount = affiliatedAccounts[0];
        } else if (contactToUpdate.primaryAccount) {
          affiliatedAccount = affiliatedAccounts.find((affiliatedAccount) => affiliatedAccount.id === contactToUpdate.primaryAccount.id);
        }
      }

      this.contactService.moveContactToSelected(contactToUpdate);

      if (affiliatedAccount) {
        this.accountService.moveAccountToSelected(affiliatedAccount);
      }

      // Fix OMNI-57394: Auto-populate location from contact address (moved outside affiliatedAccount check)
        if (this.activityService.selectedActivity.location !== "LiveMeet") {
          if (!this.authenticationService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) || (this.authenticationService.user.buConfigs && this.authenticationService.user.buConfigs['indskr_populateaccountaddress'])) {
            const previousLocation = meeting.location;
            await this.contactService.setLocationField(contactToUpdate);
            // Fix OMNI-53277: Track if location was actually changed by setLocationField
            if (meeting.location !== previousLocation) {
              locationAutoPopulated = true;
          }
        }
      }

      meetingSubjectUpdate = this.secondaryInfoService.checkIfSchemaIsConfig('indskr_contactid', SecondaryInfoEntityName.Appointment) ||
      (affiliatedAccount && this.secondaryInfoService.checkIfSchemaIsConfig('indskr_accountid', SecondaryInfoEntityName.Appointment));

      const previousSubjectOnContactAdd = meeting.subject;
      this.setMeetingSubjectFromContact(meeting,meeting.meetingOwnerName);
      if (this.secondaryInfoService.isAppointmentSecInfoConfigured && meetingSubjectUpdate) {
        meeting.subject = await this.setMeetingSubject(meeting);
      }

      const shouldCallApiForContacts = this._shouldCallMeetingApi(meeting.ID);

      if (shouldCallApiForContacts) {
        try {
          // Fix OMNI-53277: Always update if subject OR location changed to ensure location syncs to Dynamics
          if ((this.secondaryInfoService.isAppointmentSecInfoConfigured && meetingSubjectUpdate) ||
              isAutoSubjectEnabled ||
              isAcinoBaseUser ||
              locationAutoPopulated) {
            const payload = new UpdateMeetingPayload();
            if (meeting.subject !== previousSubjectOnContactAdd) payload.subject = meeting.subject;
            if (locationAutoPopulated) {
              payload.location = meeting.location;
              payload.indskr_meetinglocationlatitude  = meeting.indskr_meetinglocationlatitude  ?? null;
              payload.indskr_meetinglocationlongitude = meeting.indskr_meetinglocationlongitude ?? null;
            }
            if (Object.keys(payload.getRequestBody()).length > 0) {
              await this.updateMeeting(meeting, payload);
            }
          }
          const response: any = await this.appendContactsToMeeting(meeting.ID, [contactToUpdate]);
          let activityContacts = meeting._raw_contactAttendees;
          if (activityContacts) {
            activityContacts = [...activityContacts, ...response];
          } else {
            activityContacts = [...response];
          }
          meeting._raw_contactAttendees = activityContacts;

          if ((this.authenticationService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) || 
               this.authenticationService.hasFeatureAction(FeatureActionsMap.CAPTURE_GPS_DISTANCE_FROM_CONTACT) ||
               (currentUser.buConfigs && currentUser.buConfigs['indskr_populateaccountaddress'])) && 
               !this.activityService.isRemoteChannelEnabled(meeting.indskr_activitytype)) {
            await this.updateMeetingLocation(meeting);
          }

          if (affiliatedAccount) {
            const response = await this.appendAccountsToMeeting(meeting.ID, [affiliatedAccount]);
            let activityAccounts = meeting._raw_activityAccounts;
            if (activityAccounts) {
              activityAccounts = [...activityAccounts, ...response];
            } else {
              activityAccounts = [...response];
            }
            meeting._raw_activityAccounts = activityAccounts;
          }
          await this.activityService.upsertMeetingsOfflineData(meeting);
          await this.uiService.dismissLoader();
        } catch (error) {
          await this.uiService.dismissLoader();
          await this.activityService.upsertMeetingsOfflineData(meeting, false, true);
        }
      } else {
        await this.uiService.dismissLoader();
        await this.activityService.upsertMeetingsOfflineData(meeting);
      }

    } else if (action === 'remove') {
      let accountToRemove;

      meeting.contacts = meeting.contacts.filter((con) => con.ID !== contactToUpdate.ID);

      if (accountToRemove) {
        meeting.accounts = meeting.accounts.filter((account) => account.id !== accountToRemove.id);
      }

      // Keep location intact when contacts are removed — only update from account if GPS features require it
      if (meeting.location !== "LiveMeet") {
        if ((this.authenticationService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) ||
             this.authenticationService.hasFeatureAction(FeatureActionsMap.CAPTURE_GPS_DISTANCE_FROM_CONTACT) ||
             (currentUser.buConfigs && currentUser.buConfigs['indskr_populateaccountaddress']))) {
          await this.addAccountAddressToMeeting();
        }
      }

      const previousSubjectOnContactRemove = meeting.subject;
      this.setMeetingSubjectFromContact(meeting,meeting.meetingOwnerName);

      meetingSubjectUpdate = this.secondaryInfoService.checkIfSchemaIsConfig('indskr_contactid', SecondaryInfoEntityName.Appointment) ||
      (accountToRemove && this.secondaryInfoService.checkIfSchemaIsConfig('indskr_accountid', SecondaryInfoEntityName.Appointment));

      if (this.secondaryInfoService.isAppointmentSecInfoConfigured && meetingSubjectUpdate) {
        meeting.subject = await this.setMeetingSubject(meeting);
      }

      const shouldCallApiForContactRemove = this._shouldCallMeetingApi(meeting.ID);

      if (shouldCallApiForContactRemove) {
        try {
          await this.removeContactsFromMeeting(meeting.ID, [contactToUpdate]);
          meeting._raw_contactAttendees = this.removeRawContactAttendies(meeting, contactToUpdate.ID);
          if (accountToRemove) {
            const response: any = await this.removeAccountsFromMeeting(meeting.ID, [accountToRemove]);
            meeting._raw_activityAccounts = this.removeRawContactAttendies(meeting, accountToRemove.id);
          }

          if ((this.secondaryInfoService.isAppointmentSecInfoConfigured && meetingSubjectUpdate) || isAutoSubjectEnabled || isAcinoBaseUser) {
            if (meeting.subject !== previousSubjectOnContactRemove) {
              const payload = new UpdateMeetingPayload();
              payload.subject = meeting.subject;
              this.updateMeeting(meeting, payload);
            }
          }

          await this.uiService.dismissLoader();
          this.updateActivities(meeting);
          await this.activityService.upsertMeetingsOfflineData(meeting);
        } catch (error) {
          await this.uiService.dismissLoader();
          await this.activityService.upsertMeetingsOfflineData(meeting, false, true);
        }
      } else {
        await this.uiService.dismissLoader();
        await this.activityService.upsertMeetingsOfflineData(meeting);
      }
    }
  }

  async appendContactsToMeeting(meetingId: string, contacts: Contact[]) {
    const added = contacts.map(contact => ({
      indskr_contactid: contact.ID,
      indskr_name: contact.fullName?.trim(),
    }));

    const url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
      Endpoints.meeting.PATCH_MEETING_CONTACTS_V2.replace('{activity_id}', meetingId);

    try {
      const response: any = await this.http.patch(url, { added, removed: [] }).toPromise();
      // Map V2 response → full ContactAttendees shape so callers can spread into _raw_contactAttendees
      const createdContacts: Array<{ contactId: string, activityContactId: string }> = response?.createdContacts || [];
      const mapped = createdContacts.map(c => {
        const src = contacts.find(ct => ct.ID === c.contactId);
        return {
          activityId: meetingId,
          indskr_activitycontactid: c.activityContactId,
          indskr_contactid: c.contactId,
          indskr_name: src?.fullName?.trim() || '',
          indskr_joineddate: '',
          indskr_leftdate: '',
          indskr_sequence: null,
        };
      });
      this.logService.logDebug('appendContactsToMeeting V2:', mapped);
      return mapped;
    } catch (error) {
      console.error('appendContactsToMeeting V2:', error);
      this.errorHandler.handleError(error);
      return [];
    }
  }

  async removeContactsFromMeeting(meetingId: string, removingContacts: Contact[]) {
    const activityContacts = (this.activityService.selectedActivity as AppointmentActivity)._raw_contactAttendees;
    if (!activityContacts) return;

    const removed = removingContacts
      .map(contact => {
        const raw: any = activityContacts.find((r: any) => r.indskr_contactid === contact.ID);
        return raw ? (raw.indskr_activitycontactid || raw.contactAttendeeId) : null;
      })
      .filter(Boolean);

    if (!removed.length) return;

    const url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
      Endpoints.meeting.PATCH_MEETING_CONTACTS_V2.replace('{activity_id}', meetingId);

    try {
      return await this.http.patch(url, { added: [], removed }).toPromise();
    } catch (error) {
      console.error('removeContactsFromMeeting V2:', error);
      this.errorHandler.handleError(error);
    }
  }

  async appendAccountsToMeeting(meetingId: string, accounts: Account[]) {
    const added = accounts.map(account => ({
      accountId: account.id,
      accountName: account.accountName,
    }));

    const url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
      Endpoints.meeting.PATCH_MEETING_ACCOUNTS_V2.replace('{activity_id}', meetingId);

    try {
      const response: any = await this.http.patch(url, { added, removed: [] }).toPromise();
      // Map V2 response shape → [{indskr_activityaccountid, indskr_accountid}] for callers
      const createdAccounts: Array<{ accountId: string, activityAccountId: string }> = response?.createdAccounts || [];
      const mapped = createdAccounts.map(a => ({
        indskr_activityaccountid: a.activityAccountId,
        indskr_accountid: a.accountId,
      }));
      this.logService.logDebug('appendAccountsToMeeting V2:', mapped);
      return mapped;
    } catch (error) {
      console.error('appendAccountsToMeeting V2:', error);
      this.errorHandler.handleError(error);
      return [];
    }
  }

  async removeAccountsFromMeeting(meetingId: string, removingAccounts: Account[]) {
    const activityAccounts = (this.activityService.selectedActivity as AppointmentActivity)._raw_activityAccounts;
    if (!activityAccounts) return;

    const removed = removingAccounts
      .map(account => {
        const raw: any = activityAccounts.find((r: any) => r.indskr_accountid === account.id);
        return raw?.indskr_activityaccountid || null;
      })
      .filter(Boolean);

    if (!removed.length) return;

    const url: string = this.authenticationService.userConfig.activeInstance.entryPointUrl +
      Endpoints.meeting.PATCH_MEETING_ACCOUNTS_V2.replace('{activity_id}', meetingId);

    try {
      const response = await this.http.patch(url, { added: [], removed }).toPromise();
      this.logService.logDebug('removeAccountsFromMeeting V2:', response);
      return response;
    } catch (error) {
      console.error('removeAccountsFromMeeting V2:', error);
      this.errorHandler.handleError(error);
    }
  }

  removeRawActivityAccounts(meeting: AppointmentActivity, accountId: string) {
    if (!meeting.accounts || meeting.accounts.length == 0) return [];
    let activityAccounts = meeting._raw_activityAccounts.filter((activityAccount) => activityAccount.indskr_accountid !== accountId);
    return activityAccounts;
  }

  removeRawContactAttendies(meeting: AppointmentActivity, contactId: string) {
    if (!meeting.contacts || meeting.contacts.length == 0) return [];
    let activityContacts = meeting._raw_contactAttendees.filter((contact) => contact.indskr_contactid !== contactId);
    return activityContacts;
  }

  /**
   * Fetches related entities (accounts or contacts) for a meeting by ID.
   */
  private _fetchRelatedEntitiesByMeetingId(
    meetingId: string,
    fetchQuery: string,
    entityName: string,
    mapFn: (resp: any, meetingId: string) => any
  ): Promise<any[]> {
    // indskr_appointmentid is a GUID in Dynamics, so a meeting still carrying its
    // temporary offline id would come back as a FormatException rather than an empty
    // result. Nothing is stored against such a meeting anyway.
    if (!meetingId || meetingId.includes(OFFLINE_ID_PREFIX)) {
      return Promise.resolve([]);
    }
    return new Promise(async (resolve, reject) => {
      let fetchXML = fetchQuery;
      fetchXML = fetchXML.replace('{appointmentId}', meetingId);
      try {
        await this.dynamics.executeFetchQuery(entityName, fetchXML).then(async (response) => {
          console.log(response);
          let result = [];
          if (response && response.length > 0) {
            result = response.map((resp) => mapFn(resp, meetingId));
          }
          resolve(result);
        });
      } catch (error) {
        reject([]);
      }
    });
  }

  fetchActivityAccountsByMeetingId(meetingId: string) {
    return this._fetchRelatedEntitiesByMeetingId(
      meetingId,
      fetchQueries.fetchActivityAccountsByMeetingId,
      'indskr_activityaccounts',
      (resp, id) => ({
        activityId: id,
        indskr_accountid: resp['_indskr_accountid_value'],
        indskr_activityaccountid: resp['indskr_activityaccountid'],
        indskr_name: resp['indskr_name'],
      })
    );
  }

  fetchActivityContactAttendiesByMeetingId(meetingId: string) {
    return this._fetchRelatedEntitiesByMeetingId(
      meetingId,
      fetchQueries.fetchActivityContactAttendessByMeetingId,
      'indskr_activitycontacts',
      (resp, id) => ({
        activityId: id,
        indskr_contactid: resp['_indskr_contactid_value'],
        indskr_activitycontactid: resp['indskr_activitycontactid'],
        indskr_name: resp['indskr_name'],
      })
    );
  }

  async addActivityAccountsAndContactAttendiesToMeeting(meeting: AppointmentActivity) {
    if (this.deviceService.isOffline) return;
    // Nothing is stored against a meeting that has not reached Dynamics yet, and its
    // temporary id is not a GUID — see _fetchRelatedEntitiesByMeetingId.
    if (!meeting?.ID || meeting.ID.includes(OFFLINE_ID_PREFIX)) return;

    if (meeting.accounts.length > 0) {
      const activityAccounts: any = await this.fetchActivityAccountsByMeetingId(meeting.ID);
      if (activityAccounts) {
        meeting._raw_activityAccounts = activityAccounts;
      }
    }

    if (meeting.contacts.length > 0) {
      const activityContacts: any = await this.fetchActivityContactAttendiesByMeetingId(meeting.ID);
      if (activityContacts) {
        meeting._raw_contactAttendees = activityContacts;
      }
    }

    this.updateActivities(meeting);
  }

  updateActivities(meeting){
    let index = this.activityService.activities.findIndex(a => a.ID === meeting.ID);
    if(index >= 0){
      this.activityService.activities[index] = meeting;
    }
  }

  async updateMeetingCaptureSignatureOnline(payload, meetingId) {
    try {
      let url = this.authenticationService.userConfig.activeInstance.entryPointUrl + Endpoints.meeting.UPDATE_MEETING_CAPTURE_SIGNATURE;
      url = url.replace('{activityId}', meetingId);
      await this.http.patch(url, payload).toPromise();
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  async fetchMeetingCaptureSignatureOnline(meetingId) {
    try {
      let fetchXml = fetchQueries.fetchMeetingCaptureSignatureByMeetingId;
      fetchXml = fetchXml.replace('{meetingId}', meetingId);
      const response = await this.dynamics.executeFetchQuery('appointments', fetchXml);
      return response;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  async updateMeetingWithSignatureDate(signatureTimestamp: number) {
    const meeting = this.activityService.selectedActivity as AppointmentActivity;
    try {
      meeting.indskr_signaturedate = new Date(signatureTimestamp);
      await this.activityService.upsertMeetingsOfflineData(meeting);
    } catch (error) {
      console.log("updateMeetingWithSignatureDate ", error);
    }

  }
  
}


export class UpdateAppointmentActivityPayload {
  public activityAccounts?: Array<Account>;
  public activityPresentations?: Array<Presentation>;
  public activityProducts?: Array<Products>;
  public contactAttendees?: Array<Contact>;

  constructor(activity: AppointmentActivity) { }
}

export class UpdateMeetingPayload {
  public subject?: string;
  public location?: string;
  public scheduledStart?: Date;
  public scheduledEnd?: Date;
  public isBestTime?: boolean;
  public notes?: string;
  public meetingURL: string;
  public indskr_meetingtype: number;
  public meetingNotes?: Array<IONote>;
  public indskr_meetinglocationlatitude?:number;
  public indskr_meetinglocationlongitude?:number;
  public meetingOutcomeId?:string;
  public meetingOutcomeString?:string;
  public indskr_kitbooking?: string;
  public indskr_shortcall?:Boolean;
  public indskr_suggestionrescheduled?: Boolean

  constructor(
    subject?: string,
    location?: string,
    start?: Date,
    end?: Date,
    notes?: string,
    isBestTime?: boolean,
    meetingURL?: string,
    indskr_meetingtype?: number,
    meetingNotes?: Array<IONote>,
    indskr_meetinglocationlatitude?:number,
    indskr_meetinglocationlongitude?:number,
    meetingOutcomeId?:string,
    meetingOutcomeString?:string,
    indskr_kitbooking?: string,
    indskr_shortcall?: Boolean,
    indskr_suggestionrescheduled?: Boolean
  ) {
    this.scheduledStart = start;
    this.scheduledEnd = end;
    this.location = location;
    this.subject = subject;
    this.notes = notes;
    this.isBestTime = isBestTime;
    this.meetingURL = meetingURL;
    this.indskr_meetingtype = indskr_meetingtype;
    this.meetingNotes = meetingNotes;
    this.indskr_meetinglocationlatitude = indskr_meetinglocationlatitude;
    this.indskr_meetinglocationlongitude = indskr_meetinglocationlongitude;
    this.meetingOutcomeId = meetingOutcomeId;
    this.meetingOutcomeString = meetingOutcomeString;
    this.indskr_kitbooking = indskr_kitbooking;
    this.indskr_shortcall = indskr_shortcall;
    this.indskr_suggestionrescheduled = indskr_suggestionrescheduled;
  }

  /**
   * Returns only the fields that have been explicitly set (not undefined).
   * This matches the backend's @JsonInclude(NON_NULL) contract — only modified
   * fields are sent over the wire, avoiding spurious overwrites in Dynamics.
   */
  public getRequestBody(): Record<string, unknown> {
    const body: Record<string, unknown> = {};
    if (this.subject !== undefined)                          body['subject'] = this.subject;
    if (this.location !== undefined)                         body['location'] = this.location;
    if (this.scheduledStart !== undefined)                   body['scheduledstart'] = this.scheduledStart;
    if (this.scheduledEnd !== undefined)                     body['scheduledend'] = this.scheduledEnd;
    if (this.isBestTime !== undefined)                       body['isbesttime'] = this.isBestTime;
    if (this.notes !== undefined)                            body['indskr_notes'] = this.notes;
    if (this.indskr_meetingtype !== undefined)               body['indskr_meetingtype'] = this.indskr_meetingtype;
    if (this.indskr_meetinglocationlatitude !== undefined)   body['indskr_meetinglocationlatitude'] = this.indskr_meetinglocationlatitude;
    if (this.indskr_meetinglocationlongitude !== undefined)  body['indskr_meetinglocationlongitude'] = this.indskr_meetinglocationlongitude;
    if (this.indskr_kitbooking !== undefined)                body['indskr_kitbooking'] = this.indskr_kitbooking;
    if (this.indskr_shortcall !== undefined)                 body['indskr_shortcall'] = this.indskr_shortcall;
    if (this.indskr_suggestionrescheduled !== undefined)     body['indskr_suggestionrescheduled'] = this.indskr_suggestionrescheduled;
    return body;
  }

  /**
   * Factory that produces a minimal payload containing only fields that have
   * actually changed relative to the stored {@code original} activity.
   *
   * Use this at every PATCH call site instead of populating all fields
   * and then overwriting the one that changed.
   *
   * {@code isBestTime} is an action flag (accept recommendation) — it is always
   * included when explicitly passed, regardless of the stored value.
   */
  static diff(
    original: AppointmentActivity,
    changes: {
      subject?: string;
      location?: string;
      scheduledStart?: Date;
      scheduledEnd?: Date;
      notes?: string;
      isBestTime?: boolean;
      indskr_meetingtype?: number;
      indskr_meetinglocationlatitude?: number;
      indskr_meetinglocationlongitude?: number;
      indskr_kitbooking?: string;
      indskr_shortcall?: boolean;
      indskr_suggestionrescheduled?: boolean;
    }
  ): UpdateMeetingPayload {
    const p = new UpdateMeetingPayload();
    if (changes.subject !== undefined && changes.subject !== original.subject)
      p.subject = changes.subject;
    if (changes.location !== undefined && changes.location !== original.location)
      p.location = changes.location;
    if (changes.scheduledStart !== undefined &&
        new Date(changes.scheduledStart).getTime() !== new Date(original.scheduledStart).getTime())
      p.scheduledStart = changes.scheduledStart;
    if (changes.scheduledEnd !== undefined &&
        new Date(changes.scheduledEnd).getTime() !== new Date(original.scheduledEnd).getTime())
      p.scheduledEnd = changes.scheduledEnd;
    if (changes.notes !== undefined && changes.notes !== original.notes)
      p.notes = changes.notes;
    if (changes.isBestTime !== undefined)
      p.isBestTime = changes.isBestTime; // action flag — always included when set
    if (changes.indskr_meetingtype !== undefined && changes.indskr_meetingtype !== original.indskr_meetingtype)
      p.indskr_meetingtype = changes.indskr_meetingtype;
    if (changes.indskr_meetinglocationlatitude !== undefined && changes.indskr_meetinglocationlatitude !== original.indskr_meetinglocationlatitude)
      p.indskr_meetinglocationlatitude = changes.indskr_meetinglocationlatitude;
    if (changes.indskr_meetinglocationlongitude !== undefined && changes.indskr_meetinglocationlongitude !== original.indskr_meetinglocationlongitude)
      p.indskr_meetinglocationlongitude = changes.indskr_meetinglocationlongitude;
    if (changes.indskr_kitbooking !== undefined && changes.indskr_kitbooking !== original.indskr_kitbooking)
      p.indskr_kitbooking = changes.indskr_kitbooking;
    if (changes.indskr_shortcall !== undefined && changes.indskr_shortcall !== original.indskr_shortcall)
      p.indskr_shortcall = changes.indskr_shortcall;
    if (changes.indskr_suggestionrescheduled !== undefined && changes.indskr_suggestionrescheduled !== original.indskr_suggestionrescheduled)
      p.indskr_suggestionrescheduled = changes.indskr_suggestionrescheduled;
    return p;
  }
}


export class UpdateTypeAndSubTypeActivityPayLoad {
  public name?: string;
  public pluralEntityName?: string;
  public entity?: string;
  public id?: string;

  constructor(
    name?: string,
    pluralEntityName?: string,
    entity?: string,
    id?: string,
  ) {
    this.name = name;
    this.pluralEntityName = pluralEntityName;
    this.entity = entity;
    this.id = id;
  }

  public getRequestBody() {
    let requestBody = {
      'appconfiglookupfields': [{ name: this.name, pluralEntityName: this.pluralEntityName, entity: this.entity, id: this.id }]
    };
    return requestBody;
  }
}

export class InitiateMeetingPayload {
  public subject: string;
  public location: string;
  public scheduledStart: number;
  public scheduledEnd: number;
  public notes: string;
  public offlineMeetingId: string;
  public eventId: string;
  public accountPlanId: string;
  public shortCall: boolean;
  public kitBookingId: string;
  public indskr_activitytypeid: string;
  public activityTypeName: string;
  public indskr_activitysubtypeid: string;
  public activitySubTypeName: string;
  public isSubjectFinalForCreate: boolean = false;
  public contactForCreateSubject?: Contact;
  /** Contacts to embed in the V2 POST /meetings body — eliminates a separate PATCH round-trip. */
  public contacts?: Contact[];

  constructor(
    subject: string,
    location: string,
    start: number,
    end: number,
    notes: string,
    offlineMeetingId: string,
    accountPlanId?: string,
    shortCall?: boolean,
    kitBookingId?: string,
    indskr_activitytypeid?: string,
    activityTypeName?: string,
    indskr_activitysubtypeid?: string,
    activitySubTypeName?: string,
  ) {
    this.scheduledStart = start;
    this.scheduledEnd = end;
    this.location = location;
    this.subject = subject;
    this.notes = notes;
    this.offlineMeetingId = offlineMeetingId;
    this.accountPlanId = accountPlanId;
    this.shortCall = shortCall;
    this.kitBookingId = kitBookingId;
    this.indskr_activitytypeid = indskr_activitytypeid;
    this.activityTypeName = activityTypeName;
    this.indskr_activitysubtypeid = indskr_activitysubtypeid;
    this.activitySubTypeName = activitySubTypeName;
  }

  public getRequestBody() {
    return {
      location: this.location,
      scheduledstart: this.scheduledStart,
      scheduledend: this.scheduledEnd,
      subject: this.subject,
      indskr_notes: this.notes,
      offlineMeetingId: this.offlineMeetingId,
      accountPlanId: this.accountPlanId,
      indskr_shortcall: this.shortCall,
      indskr_kitbooking: this.kitBookingId,
      indskr_activitytype:  this.indskr_activitytypeid,
      activityTypeName: this.activityTypeName,
      indskr_activitysubtype:  this.indskr_activitysubtypeid,
      activitySubTypeName: this.activitySubTypeName
    };
  }
}

export class MeetingProduct {
  private productId: string;
}

export interface UpdateKeyMessagesFor {
  products:boolean;
  diseaseAreas:boolean;
  indications:boolean;
}
